import { ITable } from './lib/types';

export const table_cn2tw: ITable = {
	"万": "萬",
	"与": "與",
	"丑": "醜",
	"专": "專",
	"业": "業",
	"丛": "叢",
	"东": "東",
	"丝": "絲",
	"丢": "丟",
	"两": "兩",
	"严": "嚴",
	"并": "並",
	"丧": "喪",
	"个": "個",
	"丬": "爿",
	"丰": "豐",
	"临": "臨",
	"为": "為",
	"丽": "麗",
	"举": "舉",
	"么": "麼",
	"义": "義",
	"乌": "烏",
	"乐": "樂",
	"乔": "喬",
	"习": "習",
	"乡": "鄉",
	"书": "書",
	"买": "買",
	"乱": "亂",
	"干": "幹",
	"争": "爭",
	"于": "於",
	"亏": "虧",
	"云": "雲",
	"亘": "亘",
	"亚": "亞",
	"产": "產",
	"亩": "畝",
	"亲": "親",
	"亵": "褻",
	"亸": "嚲",
	"亿": "億",
	"仅": "僅",
	"仆": "僕",
	"从": "從",
	"仑": "侖",
	"仓": "倉",
	"仪": "儀",
	"们": "們",
	"价": "價",
	"众": "眾",
	"优": "優",
	"伙": "伙",
	"会": "會",
	"伛": "傴",
	"伞": "傘",
	"伟": "偉",
	"传": "傳",
	"伤": "傷",
	"伥": "倀",
	"伦": "倫",
	"伧": "傖",
	"伪": "偽",
	"伫": "佇",
	"体": "體",
	"余": "餘",
	"佣": "傭",
	"佥": "僉",
	"来": "來",
	"侠": "俠",
	"侣": "侶",
	"侥": "僥",
	"侦": "偵",
	"侧": "側",
	"侨": "僑",
	"侩": "儈",
	"侪": "儕",
	"侬": "儂",
	"俣": "俁",
	"俦": "儔",
	"俨": "儼",
	"俩": "倆",
	"俪": "儷",
	"俭": "儉",
	"债": "債",
	"倾": "傾",
	"偬": "傯",
	"偻": "僂",
	"偾": "僨",
	"偿": "償",
	"杰": "傑",
	"备": "備",
	"傥": "儻",
	"傧": "儐",
	"储": "儲",
	"傩": "儺",
	"当": "當",
	"尽": "盡",
	"罗": "羅",
	"攒": "攢",
	"儿": "兒",
	"兑": "兌",
	"兖": "兗",
	"党": "黨",
	"内": "內",
	"兰": "蘭",
	"关": "關",
	"兴": "興",
	"兹": "茲",
	"养": "養",
	"兽": "獸",
	"冁": "囅",
	"冈": "岡",
	"册": "冊",
	"写": "寫",
	"军": "軍",
	"农": "農",
	"冢": "塚",
	"幂": "冪",
	"冯": "馮",
	"冲": "衝",
	"决": "決",
	"况": "況",
	"冻": "凍",
	"净": "淨",
	"涂": "涂",
	"凄": "淒",
	"凉": "涼",
	"凌": "凌",
	"减": "減",
	"凑": "湊",
	"凛": "凜",
	"渎": "瀆",
	"几": "幾",
	"凤": "鳳",
	"处": "處",
	"凫": "鳧",
	"凭": "憑",
	"凯": "凱",
	"击": "擊",
	"凿": "鑿",
	"刍": "芻",
	"划": "劃",
	"刘": "劉",
	"则": "則",
	"刚": "剛",
	"创": "創",
	"删": "刪",
	"别": "別",
	"刭": "剄",
	"刽": "劊",
	"刿": "劌",
	"剀": "剴",
	"剂": "劑",
	"剐": "剮",
	"剑": "劍",
	"剥": "剝",
	"剧": "劇",
	"札": "札",
	"劝": "勸",
	"办": "辦",
	"务": "務",
	"劢": "勱",
	"动": "動",
	"励": "勵",
	"劲": "勁",
	"劳": "勞",
	"势": "勢",
	"勋": "勛",
	"勐": "勐",
	"勚": "勩",
	"胜": "勝",
	"绩": "績",
	"匀": "勻",
	"匦": "匭",
	"匮": "匱",
	"汇": "匯",
	"奁": "奩",
	"椟": "櫝",
	"区": "區",
	"医": "醫",
	"华": "華",
	"协": "協",
	"单": "單",
	"卖": "賣",
	"卜": "蔔",
	"卢": "盧",
	"卤": "滷",
	"卧": "臥",
	"卫": "衛",
	"却": "卻",
	"卺": "巹",
	"厂": "廠",
	"厅": "廳",
	"历": "歷",
	"厉": "厲",
	"压": "壓",
	"厌": "厭",
	"厍": "厙",
	"厕": "廁",
	"厢": "廂",
	"厣": "厴",
	"厦": "廈",
	"厨": "廚",
	"厩": "廄",
	"厮": "廝",
	"县": "縣",
	"叁": "叄",
	"参": "參",
	"叆": "靉",
	"叇": "靆",
	"双": "雙",
	"发": "發",
	"变": "變",
	"叙": "敘",
	"叠": "疊",
	"叶": "葉",
	"号": "號",
	"叹": "嘆",
	"叽": "嘰",
	"吁": "吁",
	"咤": "吒",
	"吓": "嚇",
	"吕": "呂",
	"吗": "嗎",
	"吣": "唚",
	"吨": "噸",
	"听": "聽",
	"启": "啟",
	"吴": "吳",
	"呒": "嘸",
	"呓": "囈",
	"呕": "嘔",
	"呖": "嚦",
	"呗": "唄",
	"员": "員",
	"呙": "咼",
	"呛": "嗆",
	"呜": "嗚",
	"咏": "詠",
	"咔": "咔",
	"咙": "嚨",
	"咛": "嚀",
	"咝": "噝",
	"咨": "諮",
	"咴": "噅",
	"咸": "鹹",
	"哌": "呱",
	"响": "響",
	"哑": "啞",
	"哒": "噠",
	"哓": "嘵",
	"哔": "嗶",
	"哕": "噦",
	"哗": "嘩",
	"哙": "噲",
	"哜": "嚌",
	"哝": "噥",
	"哟": "喲",
	"唣": "唕",
	"唛": "嘜",
	"唝": "嗊",
	"唠": "嘮",
	"唡": "啢",
	"唢": "嗩",
	"唤": "喚",
	"唿": "唿",
	"问": "問",
	"衔": "銜",
	"啧": "嘖",
	"啬": "嗇",
	"啭": "囀",
	"啮": "齧",
	"啰": "囉",
	"啴": "嘽",
	"啸": "嘯",
	"喷": "噴",
	"喽": "嘍",
	"喾": "嚳",
	"嗫": "囁",
	"嗬": "嗬",
	"嗳": "噯",
	"尝": "嘗",
	"嘘": "噓",
	"嘤": "嚶",
	"嘱": "囑",
	"恶": "惡",
	"噜": "嚕",
	"噼": "噼",
	"嚣": "囂",
	"嚯": "嚯",
	"苏": "蘇",
	"团": "團",
	"囱": "囪",
	"园": "園",
	"国": "國",
	"围": "圍",
	"囵": "圇",
	"图": "圖",
	"圆": "圓",
	"圣": "聖",
	"圹": "壙",
	"场": "場",
	"坂": "阪",
	"坏": "壞",
	"块": "塊",
	"坚": "堅",
	"坛": "壇",
	"坜": "壢",
	"坝": "壩",
	"坞": "塢",
	"坟": "墳",
	"坠": "墜",
	"垧": "坰",
	"垄": "壟",
	"垅": "壠",
	"垆": "壚",
	"垒": "壘",
	"垦": "墾",
	"垩": "堊",
	"垫": "墊",
	"垭": "埡",
	"垯": "墶",
	"垱": "壋",
	"垲": "塏",
	"垴": "堖",
	"埯": "垵",
	"埘": "塒",
	"埙": "塤",
	"埚": "堝",
	"埝": "墊",
	"执": "執",
	"堑": "塹",
	"堕": "墮",
	"阶": "階",
	"尧": "堯",
	"报": "報",
	"碱": "鹼",
	"塆": "壪",
	"茔": "塋",
	"塬": "原",
	"尘": "塵",
	"砖": "磚",
	"墙": "牆",
	"硗": "磽",
	"壮": "壯",
	"声": "聲",
	"壳": "殻",
	"壶": "壺",
	"壸": "壼",
	"寿": "壽",
	"复": "復",
	"够": "夠",
	"梦": "夢",
	"头": "頭",
	"夸": "誇",
	"夹": "夾",
	"夺": "奪",
	"奂": "奐",
	"奋": "奮",
	"奖": "獎",
	"奥": "奧",
	"妆": "妝",
	"妇": "婦",
	"妈": "媽",
	"妩": "嫵",
	"妪": "嫗",
	"妫": "媯",
	"姗": "姍",
	"姜": "姜",
	"娄": "婁",
	"娅": "婭",
	"娆": "嬈",
	"娇": "嬌",
	"娈": "孌",
	"娱": "娛",
	"娲": "媧",
	"娴": "嫻",
	"婳": "嫿",
	"婴": "嬰",
	"婵": "嬋",
	"婶": "嬸",
	"媪": "媼",
	"袅": "裊",
	"嫒": "嬡",
	"嫔": "嬪",
	"嫱": "嬙",
	"嬷": "嬤",
	"懒": "懶",
	"孙": "孫",
	"学": "學",
	"孪": "孿",
	"宁": "寧",
	"宝": "寶",
	"实": "實",
	"宠": "寵",
	"审": "審",
	"宪": "憲",
	"宫": "宮",
	"宽": "寬",
	"宾": "賓",
	"寝": "寢",
	"对": "對",
	"寻": "尋",
	"导": "導",
	"将": "將",
	"尔": "爾",
	"尴": "尷",
	"尸": "屍",
	"层": "層",
	"屃": "屓",
	"届": "屆",
	"屉": "屜",
	"属": "屬",
	"屡": "屢",
	"屦": "屨",
	"屿": "嶼",
	"岁": "歲",
	"岂": "豈",
	"岖": "嶇",
	"岗": "崗",
	"岘": "峴",
	"岙": "嶴",
	"岚": "嵐",
	"岛": "島",
	"岭": "嶺",
	"岳": "嶽",
	"岽": "崬",
	"岿": "巋",
	"峃": "嶨",
	"峄": "嶧",
	"峡": "峽",
	"峣": "嶢",
	"峤": "嶠",
	"峥": "崢",
	"峦": "巒",
	"崂": "嶗",
	"崃": "崍",
	"崄": "嶮",
	"崭": "嶄",
	"嵛": "崳",
	"嵘": "嶸",
	"嵚": "嶔",
	"嵝": "嶁",
	"嵴": "脊",
	"巅": "巔",
	"巩": "鞏",
	"巯": "巰",
	"币": "幣",
	"帅": "帥",
	"师": "師",
	"帏": "幃",
	"帐": "帳",
	"帘": "簾",
	"帜": "幟",
	"带": "帶",
	"帧": "幀",
	"帮": "幫",
	"帱": "幬",
	"帻": "幘",
	"帼": "幗",
	"幞": "襆",
	"襕": "幱",
	"幺": "么",
	"广": "廣",
	"庄": "莊",
	"庆": "慶",
	"庐": "廬",
	"庑": "廡",
	"库": "庫",
	"应": "應",
	"庙": "廟",
	"庞": "龐",
	"废": "廢",
	"庼": "廎",
	"荫": "蔭",
	"廪": "廩",
	"开": "開",
	"异": "異",
	"弃": "棄",
	"张": "張",
	"弥": "彌",
	"弪": "弳",
	"弯": "彎",
	"强": "強",
	"弹": "彈",
	"归": "歸",
	"录": "錄",
	"彟": "彠",
	"彦": "彥",
	"彻": "徹",
	"径": "徑",
	"徕": "徠",
	"御": "御",
	"忆": "憶",
	"忏": "懺",
	"忧": "憂",
	"忾": "愾",
	"怀": "懷",
	"态": "態",
	"怂": "慫",
	"怃": "憮",
	"怄": "慪",
	"怅": "悵",
	"怆": "愴",
	"怜": "憐",
	"总": "總",
	"怼": "懟",
	"怿": "懌",
	"恋": "戀",
	"耻": "恥",
	"恳": "懇",
	"恸": "慟",
	"恹": "懨",
	"恺": "愷",
	"恻": "惻",
	"恼": "惱",
	"恽": "惲",
	"悦": "悅",
	"悫": "愨",
	"悬": "懸",
	"悭": "慳",
	"悯": "憫",
	"闷": "悶",
	"惊": "驚",
	"惧": "懼",
	"惨": "慘",
	"惩": "懲",
	"惫": "憊",
	"惬": "愜",
	"惭": "慚",
	"惮": "憚",
	"惯": "慣",
	"愍": "湣",
	"爱": "愛",
	"愠": "慍",
	"愤": "憤",
	"愦": "憒",
	"愿": "願",
	"慑": "懾",
	"慭": "憖",
	"虑": "慮",
	"憷": "憷",
	"懔": "懍",
	"懑": "懣",
	"欢": "歡",
	"戆": "戇",
	"戋": "戔",
	"戏": "戲",
	"戗": "戧",
	"战": "戰",
	"戬": "戩",
	"户": "戶",
	"扎": "扎",
	"扑": "撲",
	"扦": "扦",
	"扩": "擴",
	"扪": "捫",
	"扫": "掃",
	"扬": "揚",
	"扰": "擾",
	"抚": "撫",
	"抛": "拋",
	"抟": "摶",
	"抠": "摳",
	"抡": "掄",
	"抢": "搶",
	"护": "護",
	"担": "擔",
	"拟": "擬",
	"拢": "攏",
	"拣": "揀",
	"拥": "擁",
	"拦": "攔",
	"拧": "擰",
	"拨": "撥",
	"择": "擇",
	"挂": "掛",
	"挚": "摯",
	"挛": "攣",
	"挜": "掗",
	"挝": "撾",
	"挞": "撻",
	"挟": "挾",
	"挠": "撓",
	"挡": "擋",
	"挢": "撟",
	"挣": "掙",
	"挤": "擠",
	"挥": "揮",
	"挦": "撏",
	"捞": "撈",
	"损": "損",
	"捡": "撿",
	"换": "換",
	"捣": "搗",
	"据": "據",
	"捻": "捻",
	"掳": "擄",
	"掴": "摑",
	"掷": "擲",
	"掸": "撣",
	"掺": "摻",
	"掼": "摜",
	"揸": "摣",
	"揽": "攬",
	"揿": "撳",
	"搀": "攙",
	"搁": "擱",
	"搂": "摟",
	"搅": "攪",
	"构": "構",
	"摇": "搖",
	"携": "攜",
	"摄": "攝",
	"摅": "攄",
	"摆": "擺",
	"摈": "擯",
	"摊": "攤",
	"撄": "攖",
	"撑": "撐",
	"撵": "攆",
	"撷": "擷",
	"撸": "擼",
	"撺": "攛",
	"擞": "擻",
	"敌": "敵",
	"败": "敗",
	"敛": "斂",
	"数": "數",
	"驱": "驅",
	"毙": "斃",
	"斋": "齋",
	"斓": "斕",
	"斗": "鬥",
	"斩": "斬",
	"断": "斷",
	"无": "無",
	"旧": "舊",
	"时": "時",
	"旷": "曠",
	"旸": "暘",
	"昙": "曇",
	"昼": "晝",
	"昽": "曨",
	"显": "顯",
	"晋": "晉",
	"晒": "曬",
	"晓": "曉",
	"晔": "曄",
	"晕": "暈",
	"晖": "暉",
	"暂": "暫",
	"畅": "暢",
	"暧": "曖",
	"胧": "朧",
	"术": "術",
	"朴": "樸",
	"机": "機",
	"杀": "殺",
	"杂": "雜",
	"权": "權",
	"条": "條",
	"杨": "楊",
	"杩": "榪",
	"极": "極",
	"枞": "樅",
	"枢": "樞",
	"枣": "棗",
	"枥": "櫪",
	"枧": "梘",
	"枨": "棖",
	"枪": "槍",
	"枫": "楓",
	"枭": "梟",
	"柜": "櫃",
	"柠": "檸",
	"栅": "柵",
	"柽": "檉",
	"栀": "梔",
	"标": "標",
	"栈": "棧",
	"栉": "櫛",
	"栊": "櫳",
	"栋": "棟",
	"栌": "櫨",
	"栎": "櫟",
	"栏": "欄",
	"树": "樹",
	"栖": "棲",
	"样": "樣",
	"栾": "欒",
	"桊": "棬",
	"桠": "椏",
	"桡": "橈",
	"桢": "楨",
	"档": "檔",
	"桤": "榿",
	"桥": "橋",
	"桦": "樺",
	"桧": "檜",
	"桨": "槳",
	"桩": "樁",
	"梼": "檮",
	"梾": "棶",
	"检": "檢",
	"棂": "欞",
	"椁": "槨",
	"椠": "槧",
	"椤": "欏",
	"椭": "橢",
	"楼": "樓",
	"榄": "欖",
	"榇": "櫬",
	"榈": "櫚",
	"榉": "櫸",
	"荣": "榮",
	"盘": "盤",
	"槚": "檟",
	"槛": "檻",
	"槟": "檳",
	"槠": "櫧",
	"规": "規",
	"横": "橫",
	"樯": "檣",
	"樱": "櫻",
	"橥": "櫫",
	"橱": "櫥",
	"橹": "櫓",
	"橼": "櫞",
	"檩": "檁",
	"檐": "檐",
	"苘": "檾",
	"欤": "歟",
	"欧": "歐",
	"钦": "欽",
	"歼": "殲",
	"殁": "歿",
	"殇": "殤",
	"残": "殘",
	"殒": "殞",
	"殓": "殮",
	"殚": "殫",
	"殡": "殯",
	"殴": "毆",
	"毁": "毀",
	"毂": "轂",
	"毕": "畢",
	"毡": "氈",
	"绒": "絨",
	"毵": "毿",
	"牦": "氂",
	"氇": "氌",
	"气": "氣",
	"氢": "氫",
	"氩": "氬",
	"氲": "氳",
	"汉": "漢",
	"污": "污",
	"汤": "湯",
	"汹": "洶",
	"没": "沒",
	"沓": "沓",
	"沟": "溝",
	"沣": "灃",
	"沤": "漚",
	"沥": "瀝",
	"沦": "淪",
	"沧": "滄",
	"沨": "渢",
	"沩": "溈",
	"沪": "滬",
	"沵": "濔",
	"泞": "濘",
	"泪": "淚",
	"泶": "澩",
	"泷": "瀧",
	"泸": "瀘",
	"泺": "濼",
	"泻": "瀉",
	"泼": "潑",
	"泽": "澤",
	"泾": "涇",
	"洁": "潔",
	"洒": "灑",
	"洼": "窪",
	"浃": "浹",
	"浅": "淺",
	"浆": "漿",
	"浇": "澆",
	"浈": "湞",
	"浉": "溮",
	"浊": "濁",
	"测": "測",
	"浍": "澮",
	"济": "濟",
	"浏": "瀏",
	"浐": "滻",
	"浑": "渾",
	"浒": "滸",
	"浓": "濃",
	"浔": "潯",
	"浕": "濜",
	"涌": "涌",
	"莅": "蒞",
	"涛": "濤",
	"涝": "澇",
	"涞": "淶",
	"涟": "漣",
	"涠": "潿",
	"涡": "渦",
	"涢": "溳",
	"涣": "渙",
	"涤": "滌",
	"润": "潤",
	"涧": "澗",
	"涨": "漲",
	"涩": "澀",
	"淀": "澱",
	"渌": "淥",
	"渊": "淵",
	"渍": "漬",
	"渐": "漸",
	"渑": "澠",
	"渔": "漁",
	"渖": "瀋",
	"渗": "滲",
	"温": "溫",
	"游": "游",
	"湾": "灣",
	"湿": "濕",
	"溃": "潰",
	"溅": "濺",
	"溆": "漵",
	"溇": "漊",
	"灭": "滅",
	"荥": "滎",
	"滗": "潷",
	"滚": "滾",
	"滞": "滯",
	"滟": "灧",
	"滠": "灄",
	"满": "滿",
	"滢": "瀅",
	"滤": "濾",
	"滥": "濫",
	"滦": "灤",
	"滨": "濱",
	"滩": "灘",
	"滪": "澦",
	"漤": "灠",
	"颍": "潁",
	"潆": "瀠",
	"潇": "瀟",
	"潋": "瀲",
	"潍": "濰",
	"潜": "潛",
	"潴": "瀦",
	"澜": "瀾",
	"濑": "瀨",
	"濒": "瀕",
	"阔": "闊",
	"灏": "灝",
	"灯": "燈",
	"灵": "靈",
	"灾": "災",
	"灿": "燦",
	"炀": "煬",
	"炉": "爐",
	"炖": "燉",
	"炜": "煒",
	"炝": "熗",
	"点": "點",
	"炼": "煉",
	"炽": "熾",
	"烁": "爍",
	"烂": "爛",
	"烃": "烴",
	"烛": "燭",
	"烟": "煙",
	"烦": "煩",
	"烧": "燒",
	"烨": "燁",
	"烩": "燴",
	"烫": "燙",
	"烬": "燼",
	"热": "熱",
	"焕": "煥",
	"焖": "燜",
	"焘": "燾",
	"煅": "煆",
	"辉": "輝",
	"茕": "煢",
	"煳": "糊",
	"煺": "退",
	"荧": "熒",
	"熘": "溜",
	"颎": "熲",
	"营": "營",
	"爷": "爺",
	"笺": "箋",
	"牍": "牘",
	"闸": "閘",
	"牵": "牽",
	"牺": "犧",
	"犊": "犢",
	"荦": "犖",
	"犟": "犟",
	"犭": "犬",
	"状": "狀",
	"犷": "獷",
	"犸": "獁",
	"犹": "猶",
	"狈": "狽",
	"狍": "麅",
	"狝": "獮",
	"狞": "獰",
	"独": "獨",
	"狭": "狹",
	"狮": "獅",
	"狯": "獪",
	"狰": "猙",
	"狱": "獄",
	"狲": "猻",
	"猃": "獫",
	"猎": "獵",
	"猕": "獼",
	"猡": "玀",
	"猪": "豬",
	"猫": "貓",
	"猬": "蝟",
	"献": "獻",
	"獭": "獺",
	"获": "獲",
	"玑": "璣",
	"玙": "璵",
	"玚": "瑒",
	"玛": "瑪",
	"珏": "玨",
	"玮": "瑋",
	"环": "環",
	"现": "現",
	"玱": "瑲",
	"玺": "璽",
	"珉": "瑉",
	"珐": "琺",
	"珑": "瓏",
	"珰": "璫",
	"珲": "琿",
	"琎": "璡",
	"琏": "璉",
	"琐": "瑣",
	"琼": "瓊",
	"瑶": "瑤",
	"莹": "瑩",
	"瑷": "璦",
	"璇": "璿",
	"璎": "瓔",
	"瓒": "瓚",
	"瓮": "瓮",
	"瓯": "甌",
	"罂": "罌",
	"电": "電",
	"画": "畫",
	"畴": "疇",
	"疖": "癤",
	"疗": "療",
	"疟": "瘧",
	"疠": "癘",
	"疡": "瘍",
	"疬": "癧",
	"疮": "瘡",
	"疯": "瘋",
	"疱": "皰",
	"疴": "痾",
	"痈": "癰",
	"痉": "痙",
	"痒": "癢",
	"痖": "瘂",
	"痨": "癆",
	"痪": "瘓",
	"痫": "癇",
	"痴": "痴",
	"瘅": "癉",
	"瘆": "瘮",
	"瘗": "瘞",
	"瘘": "瘺",
	"瘪": "癟",
	"瘫": "癱",
	"瘾": "癮",
	"瘿": "癭",
	"癞": "癩",
	"癣": "癬",
	"癫": "癲",
	"癯": "臒",
	"皑": "皚",
	"皱": "皺",
	"皲": "皸",
	"盏": "盞",
	"盐": "鹽",
	"监": "監",
	"盖": "蓋",
	"盗": "盜",
	"荡": "蕩",
	"眍": "瞘",
	"视": "視",
	"眦": "眥",
	"眬": "矓",
	"着": "著",
	"睁": "睜",
	"睐": "睞",
	"睑": "瞼",
	"瞆": "瞶",
	"瞒": "瞞",
	"瞩": "矚",
	"矫": "矯",
	"矶": "磯",
	"硅": "硅",
	"矾": "礬",
	"矿": "礦",
	"砀": "碭",
	"码": "碼",
	"砗": "硨",
	"砚": "硯",
	"砜": "碸",
	"砺": "礪",
	"砻": "礱",
	"砾": "礫",
	"础": "礎",
	"硁": "硜",
	"硕": "碩",
	"硖": "硤",
	"硙": "磑",
	"硚": "礄",
	"确": "確",
	"碜": "磣",
	"硷": "鹼",
	"碍": "礙",
	"碛": "磧",
	"碹": "碹",
	"磙": "滾",
	"礼": "禮",
	"祎": "禕",
	"祢": "禰",
	"祯": "禎",
	"祷": "禱",
	"祸": "禍",
	"禄": "祿",
	"禀": "稟",
	"禅": "禪",
	"离": "離",
	"秃": "禿",
	"秆": "稈",
	"籼": "秈",
	"种": "種",
	"积": "積",
	"称": "稱",
	"秽": "穢",
	"秾": "穠",
	"税": "稅",
	"稆": "穭",
	"稣": "穌",
	"稳": "穩",
	"谷": "穀",
	"颖": "穎",
	"穑": "穡",
	"颓": "穨",
	"穷": "窮",
	"窃": "竊",
	"窍": "竅",
	"窑": "窯",
	"窜": "竄",
	"窝": "窩",
	"窥": "窺",
	"窦": "竇",
	"窭": "窶",
	"竖": "豎",
	"竞": "競",
	"笃": "篤",
	"笋": "筍",
	"笔": "筆",
	"笕": "筧",
	"笼": "籠",
	"笾": "籩",
	"筑": "築",
	"筚": "篳",
	"筛": "篩",
	"筜": "簹",
	"筝": "箏",
	"筹": "籌",
	"签": "簽",
	"简": "簡",
	"箓": "籙",
	"箦": "簀",
	"箧": "篋",
	"箨": "籜",
	"箩": "籮",
	"箪": "簞",
	"箫": "簫",
	"节": "節",
	"范": "範",
	"篑": "簣",
	"篓": "簍",
	"篮": "籃",
	"篱": "籬",
	"簖": "籪",
	"籁": "籟",
	"钥": "鑰",
	"籴": "糴",
	"类": "類",
	"粜": "糶",
	"粝": "糲",
	"粤": "粵",
	"粪": "糞",
	"粮": "糧",
	"糁": "糝",
	"糇": "餱",
	"纟": "糹",
	"纠": "糾",
	"纪": "紀",
	"纣": "紂",
	"约": "約",
	"红": "紅",
	"纡": "紆",
	"纥": "紇",
	"纨": "紈",
	"纫": "紉",
	"纹": "紋",
	"纳": "納",
	"纽": "紐",
	"纾": "紓",
	"纯": "純",
	"纰": "紕",
	"纼": "紖",
	"纱": "紗",
	"纮": "紘",
	"纸": "紙",
	"级": "級",
	"纷": "紛",
	"纭": "紜",
	"纴": "紝",
	"纺": "紡",
	"紧": "緊",
	"细": "細",
	"绂": "紱",
	"绁": "紲",
	"绅": "紳",
	"纻": "紵",
	"绍": "紹",
	"绀": "紺",
	"绋": "紼",
	"绐": "紿",
	"绌": "絀",
	"终": "終",
	"组": "組",
	"绊": "絆",
	"绗": "絎",
	"结": "結",
	"绝": "絕",
	"绦": "絛",
	"绔": "絝",
	"绞": "絞",
	"络": "絡",
	"绚": "絢",
	"给": "給",
	"绖": "絰",
	"统": "統",
	"绛": "絳",
	"絷": "縶",
	"绢": "絹",
	"绑": "綁",
	"绡": "綃",
	"绠": "綆",
	"绨": "綈",
	"绣": "綉",
	"绤": "綌",
	"绥": "綏",
	"经": "經",
	"综": "綜",
	"缍": "綞",
	"绿": "綠",
	"绸": "綢",
	"绻": "綣",
	"线": "綫",
	"绶": "綬",
	"维": "維",
	"绹": "綯",
	"绾": "綰",
	"纲": "綱",
	"网": "網",
	"绷": "綳",
	"缀": "綴",
	"纶": "綸",
	"绺": "綹",
	"绮": "綺",
	"绽": "綻",
	"绰": "綽",
	"绫": "綾",
	"绵": "綿",
	"绲": "緄",
	"缁": "緇",
	"绯": "緋",
	"缗": "緡",
	"绪": "緒",
	"绬": "緓",
	"绱": "緔",
	"缃": "緗",
	"缄": "緘",
	"缂": "緙",
	"缉": "緝",
	"缎": "緞",
	"缔": "締",
	"缘": "緣",
	"缌": "緦",
	"编": "編",
	"缓": "緩",
	"缅": "緬",
	"纬": "緯",
	"缑": "緱",
	"缈": "緲",
	"练": "練",
	"缏": "緶",
	"缇": "緹",
	"缊": "縕",
	"萦": "縈",
	"缙": "縉",
	"缢": "縊",
	"缒": "縋",
	"绉": "縐",
	"缣": "縑",
	"缞": "縗",
	"缚": "縛",
	"缜": "縝",
	"缟": "縞",
	"缛": "縟",
	"缝": "縫",
	"缡": "縭",
	"缩": "縮",
	"纵": "縱",
	"缧": "縲",
	"纤": "纖",
	"缦": "縵",
	"缕": "縷",
	"缥": "縹",
	"缫": "繅",
	"缪": "繆",
	"襁": "繈",
	"缯": "繒",
	"织": "織",
	"缮": "繕",
	"缭": "繚",
	"绕": "繞",
	"缋": "繢",
	"绳": "繩",
	"绘": "繪",
	"茧": "繭",
	"缰": "繮",
	"缳": "繯",
	"缲": "繰",
	"缴": "繳",
	"绎": "繹",
	"继": "繼",
	"缤": "繽",
	"缱": "繾",
	"颣": "纇",
	"缬": "纈",
	"纩": "纊",
	"续": "續",
	"缠": "纏",
	"缨": "纓",
	"缵": "纘",
	"缆": "纜",
	"缐": "線",
	"钵": "缽",
	"罚": "罰",
	"罢": "罷",
	"罴": "羆",
	"骂": "罵",
	"羁": "羈",
	"芈": "羋",
	"羟": "羥",
	"羡": "羨",
	"翘": "翹",
	"翙": "翽",
	"翚": "翬",
	"锄": "鋤",
	"耢": "耮",
	"耧": "耬",
	"耸": "聳",
	"聂": "聶",
	"聋": "聾",
	"职": "職",
	"聍": "聹",
	"联": "聯",
	"闻": "聞",
	"聩": "聵",
	"聪": "聰",
	"肃": "肅",
	"肠": "腸",
	"肤": "膚",
	"肷": "膁",
	"肾": "腎",
	"肿": "腫",
	"胀": "脹",
	"胁": "脅",
	"胆": "膽",
	"胨": "腖",
	"胪": "臚",
	"胫": "脛",
	"胶": "膠",
	"脉": "脈",
	"脍": "膾",
	"脏": "髒",
	"脐": "臍",
	"脑": "腦",
	"脓": "膿",
	"脔": "臠",
	"脚": "腳",
	"脱": "脫",
	"脶": "腡",
	"脸": "臉",
	"腊": "臘",
	"腌": "醃",
	"腘": "膕",
	"腭": "齶",
	"腻": "膩",
	"腼": "靦",
	"腽": "膃",
	"腾": "騰",
	"膑": "臏",
	"臜": "臢",
	"舆": "輿",
	"铺": "鋪",
	"馆": "館",
	"舣": "艤",
	"舰": "艦",
	"舱": "艙",
	"舻": "艫",
	"艰": "艱",
	"艳": "艷",
	"艹": "艸",
	"艺": "藝",
	"芗": "薌",
	"芜": "蕪",
	"芦": "蘆",
	"苁": "蓯",
	"苇": "葦",
	"苈": "藶",
	"苋": "莧",
	"苌": "萇",
	"苍": "蒼",
	"苎": "苧",
	"苹": "蘋",
	"茎": "莖",
	"茏": "蘢",
	"茑": "蔦",
	"荆": "荊",
	"荐": "薦",
	"荙": "薘",
	"荚": "莢",
	"荛": "蕘",
	"荜": "蓽",
	"荞": "蕎",
	"荟": "薈",
	"荠": "薺",
	"荤": "葷",
	"荨": "蕁",
	"荩": "藎",
	"荪": "蓀",
	"荬": "蕒",
	"荭": "葒",
	"荮": "葤",
	"药": "藥",
	"莜": "蓧",
	"莱": "萊",
	"莲": "蓮",
	"莳": "蒔",
	"莴": "萵",
	"莶": "薟",
	"莸": "蕕",
	"莺": "鶯",
	"莼": "蓴",
	"萚": "蘀",
	"萝": "蘿",
	"萤": "螢",
	"萧": "蕭",
	"萨": "薩",
	"葱": "蔥",
	"蒇": "蕆",
	"蒉": "蕢",
	"蒋": "蔣",
	"蒌": "蔞",
	"蓝": "藍",
	"蓟": "薊",
	"蓠": "蘺",
	"蓣": "蕷",
	"蓥": "鎣",
	"蓦": "驀",
	"蔷": "薔",
	"蔹": "蘞",
	"蔺": "藺",
	"蔼": "藹",
	"蕲": "蘄",
	"蕴": "蘊",
	"薮": "藪",
	"藁": "槁",
	"藓": "蘚",
	"虏": "虜",
	"虚": "虛",
	"虫": "蟲",
	"虬": "虯",
	"虮": "蟣",
	"虽": "雖",
	"虾": "蝦",
	"虿": "蠆",
	"蚀": "蝕",
	"蚁": "蟻",
	"蚂": "螞",
	"蚕": "蠶",
	"蚝": "蠔",
	"蚬": "蜆",
	"蛊": "蠱",
	"蛎": "蠣",
	"蛏": "蟶",
	"蛮": "蠻",
	"蛰": "蟄",
	"蛱": "蛺",
	"蛲": "蟯",
	"蛳": "螄",
	"蛴": "蠐",
	"蜕": "蛻",
	"蜗": "蝸",
	"蜡": "蠟",
	"蝇": "蠅",
	"蝈": "蟈",
	"蝉": "蟬",
	"蝎": "蠍",
	"蝼": "螻",
	"蝾": "蠑",
	"螀": "螿",
	"螨": "蟎",
	"蟏": "蠨",
	"衅": "釁",
	"补": "補",
	"衬": "襯",
	"衮": "袞",
	"袄": "襖",
	"袆": "褘",
	"袜": "襪",
	"袭": "襲",
	"袯": "襏",
	"装": "裝",
	"裆": "襠",
	"裈": "褌",
	"里": "裡",
	"裢": "褳",
	"裣": "襝",
	"裤": "褲",
	"裥": "襇",
	"褛": "褸",
	"褴": "襤",
	"见": "見",
	"觃": "覎",
	"觅": "覓",
	"觇": "覘",
	"觋": "覡",
	"觍": "覥",
	"觎": "覦",
	"觊": "覬",
	"觏": "覯",
	"觑": "覷",
	"觐": "覲",
	"觉": "覺",
	"览": "覽",
	"觌": "覿",
	"观": "觀",
	"觞": "觴",
	"触": "觸",
	"觯": "觶",
	"讠": "訁",
	"订": "訂",
	"讣": "訃",
	"计": "計",
	"讯": "訊",
	"讧": "訌",
	"讨": "討",
	"讦": "訐",
	"讱": "訒",
	"训": "訓",
	"讪": "訕",
	"讫": "訖",
	"记": "記",
	"讹": "訛",
	"讶": "訝",
	"讼": "訟",
	"诀": "訣",
	"讷": "訥",
	"谌": "諶",
	"讻": "訩",
	"访": "訪",
	"设": "設",
	"许": "許",
	"诉": "訴",
	"诃": "訶",
	"诊": "診",
	"证": "證",
	"诂": "詁",
	"诋": "詆",
	"讵": "詎",
	"诈": "詐",
	"诒": "詒",
	"诏": "詔",
	"评": "評",
	"诐": "詖",
	"诇": "詗",
	"诎": "詘",
	"诅": "詛",
	"词": "詞",
	"詟": "讋",
	"诩": "詡",
	"询": "詢",
	"诣": "詣",
	"试": "試",
	"诗": "詩",
	"诧": "詫",
	"诟": "詬",
	"诡": "詭",
	"诠": "詮",
	"诘": "詰",
	"话": "話",
	"该": "該",
	"详": "詳",
	"诜": "詵",
	"诙": "詼",
	"诖": "詿",
	"诔": "誄",
	"诛": "誅",
	"诓": "誆",
	"誉": "譽",
	"誊": "謄",
	"认": "認",
	"诳": "誑",
	"诶": "誒",
	"诞": "誕",
	"诱": "誘",
	"诮": "誚",
	"语": "語",
	"诚": "誠",
	"诫": "誡",
	"诬": "誣",
	"误": "誤",
	"诰": "誥",
	"诵": "誦",
	"诲": "誨",
	"说": "說",
	"谁": "誰",
	"课": "課",
	"谇": "誶",
	"诽": "誹",
	"谊": "誼",
	"调": "調",
	"谄": "諂",
	"谆": "諄",
	"谈": "談",
	"诿": "諉",
	"请": "請",
	"诤": "諍",
	"诹": "諏",
	"诼": "諑",
	"谅": "諒",
	"论": "論",
	"谂": "諗",
	"谀": "諛",
	"谍": "諜",
	"谞": "諝",
	"谝": "諞",
	"谥": "謚",
	"诨": "諢",
	"谔": "諤",
	"谛": "諦",
	"谐": "諧",
	"谏": "諫",
	"谕": "諭",
	"讳": "諱",
	"谙": "諳",
	"讽": "諷",
	"诸": "諸",
	"谚": "諺",
	"谖": "諼",
	"诺": "諾",
	"谋": "謀",
	"谒": "謁",
	"谓": "謂",
	"诌": "謅",
	"谎": "謊",
	"谜": "謎",
	"谧": "謐",
	"谑": "謔",
	"谡": "謖",
	"谤": "謗",
	"谦": "謙",
	"讲": "講",
	"谢": "謝",
	"谣": "謠",
	"谟": "謨",
	"谪": "謫",
	"谬": "謬",
	"讴": "謳",
	"谨": "謹",
	"谩": "謾",
	"谲": "譎",
	"讥": "譏",
	"谮": "譖",
	"识": "識",
	"谯": "譙",
	"谭": "譚",
	"谱": "譜",
	"谵": "譫",
	"译": "譯",
	"议": "議",
	"谴": "譴",
	"诪": "譸",
	"谫": "譾",
	"读": "讀",
	"雠": "讎",
	"谗": "讒",
	"让": "讓",
	"谰": "讕",
	"谶": "讖",
	"赞": "贊",
	"谠": "讜",
	"谳": "讞",
	"谘": "諮",
	"豮": "豶",
	"贝": "貝",
	"贞": "貞",
	"贠": "貟",
	"负": "負",
	"财": "財",
	"贡": "貢",
	"贫": "貧",
	"货": "貨",
	"贩": "販",
	"贪": "貪",
	"贯": "貫",
	"责": "責",
	"贮": "貯",
	"贳": "貰",
	"赀": "貲",
	"贰": "貳",
	"贵": "貴",
	"贬": "貶",
	"贷": "貸",
	"贶": "貺",
	"费": "費",
	"贴": "貼",
	"贻": "貽",
	"贸": "貿",
	"贺": "賀",
	"贲": "賁",
	"赂": "賂",
	"赁": "賃",
	"贿": "賄",
	"赅": "賅",
	"资": "資",
	"贾": "賈",
	"贼": "賊",
	"赃": "贓",
	"赈": "賑",
	"赊": "賒",
	"赇": "賕",
	"赒": "賙",
	"赉": "賚",
	"赐": "賜",
	"赏": "賞",
	"赔": "賠",
	"赓": "賡",
	"贤": "賢",
	"贱": "賤",
	"赋": "賦",
	"赕": "賧",
	"质": "質",
	"赍": "賫",
	"账": "賬",
	"赌": "賭",
	"赆": "贐",
	"赖": "賴",
	"赗": "賵",
	"赚": "賺",
	"赙": "賻",
	"购": "購",
	"赛": "賽",
	"赜": "賾",
	"贽": "贄",
	"赘": "贅",
	"赟": "贇",
	"赠": "贈",
	"赝": "贋",
	"赡": "贍",
	"赢": "贏",
	"赑": "贔",
	"赎": "贖",
	"赣": "贛",
	"赪": "赬",
	"赵": "趙",
	"赶": "趕",
	"趋": "趨",
	"趱": "趲",
	"趸": "躉",
	"跃": "躍",
	"跄": "蹌",
	"跖": "跖",
	"跞": "躒",
	"迹": "跡",
	"践": "踐",
	"跶": "躂",
	"跷": "蹺",
	"跸": "蹕",
	"跹": "躚",
	"跻": "躋",
	"踊": "踴",
	"踌": "躊",
	"踪": "蹤",
	"踬": "躓",
	"踯": "躑",
	"蹑": "躡",
	"蹒": "蹣",
	"蹰": "躕",
	"蹿": "躥",
	"躏": "躪",
	"躜": "躦",
	"躯": "軀",
	"车": "車",
	"轧": "軋",
	"轨": "軌",
	"轪": "軑",
	"轩": "軒",
	"轫": "軔",
	"轭": "軛",
	"软": "軟",
	"轷": "軤",
	"轸": "軫",
	"轱": "軲",
	"轴": "軸",
	"轵": "軹",
	"轺": "軺",
	"轲": "軻",
	"轶": "軼",
	"轼": "軾",
	"较": "較",
	"辂": "輅",
	"辁": "輇",
	"辀": "輈",
	"载": "載",
	"轾": "輊",
	"辄": "輒",
	"辅": "輔",
	"轻": "輕",
	"辆": "輛",
	"辎": "輜",
	"辋": "輞",
	"辍": "輟",
	"辊": "輥",
	"辇": "輦",
	"辈": "輩",
	"轮": "輪",
	"辌": "輬",
	"辑": "輯",
	"辏": "輳",
	"输": "輸",
	"辐": "輻",
	"辒": "轀",
	"辗": "輾",
	"辖": "轄",
	"辕": "轅",
	"辘": "轆",
	"转": "轉",
	"辙": "轍",
	"轿": "轎",
	"辚": "轔",
	"轰": "轟",
	"辔": "轡",
	"轹": "轢",
	"轳": "轤",
	"辞": "辭",
	"辩": "辯",
	"辫": "辮",
	"边": "邊",
	"辽": "遼",
	"达": "達",
	"迁": "遷",
	"过": "過",
	"迈": "邁",
	"运": "運",
	"还": "還",
	"这": "這",
	"进": "進",
	"远": "遠",
	"违": "違",
	"连": "連",
	"迟": "遲",
	"迩": "邇",
	"迳": "逕",
	"适": "適",
	"选": "選",
	"逊": "遜",
	"递": "遞",
	"逦": "邐",
	"逻": "邏",
	"遗": "遺",
	"遥": "遙",
	"邓": "鄧",
	"邝": "鄺",
	"邬": "鄔",
	"邮": "郵",
	"邹": "鄒",
	"邺": "鄴",
	"邻": "鄰",
	"郁": "郁",
	"郄": "郤",
	"郏": "郟",
	"郐": "鄶",
	"郑": "鄭",
	"郓": "鄆",
	"郦": "酈",
	"郧": "鄖",
	"郸": "鄲",
	"酝": "醞",
	"酦": "醱",
	"酰": "醯",
	"酱": "醬",
	"酽": "釅",
	"酾": "釃",
	"酿": "釀",
	"释": "釋",
	"钆": "釓",
	"钇": "釔",
	"钌": "釕",
	"钊": "釗",
	"钉": "釘",
	"钋": "釙",
	"针": "針",
	"钓": "釣",
	"钐": "釤",
	"钏": "釧",
	"钒": "釩",
	"钗": "釵",
	"钍": "釷",
	"钕": "釹",
	"钎": "釺",
	"钯": "鈀",
	"钫": "鈁",
	"钘": "鈃",
	"钭": "鈄",
	"钚": "鈈",
	"钠": "鈉",
	"钝": "鈍",
	"钩": "鈎",
	"钤": "鈐",
	"钣": "鈑",
	"钑": "鈒",
	"钞": "鈔",
	"钮": "鈕",
	"钧": "鈞",
	"钟": "鐘",
	"钙": "鈣",
	"钬": "鈥",
	"钛": "鈦",
	"钪": "鈧",
	"铌": "鈮",
	"铈": "鈰",
	"钶": "鈳",
	"铃": "鈴",
	"钴": "鈷",
	"钹": "鈸",
	"铍": "鈹",
	"钰": "鈺",
	"钸": "鈽",
	"铀": "鈾",
	"钿": "鈿",
	"钾": "鉀",
	"铁": "鐵",
	"钻": "鑽",
	"铊": "鉈",
	"铉": "鉉",
	"铋": "鉍",
	"铂": "鉑",
	"钷": "鉕",
	"钳": "鉗",
	"铆": "鉚",
	"铅": "鉛",
	"钺": "鉞",
	"钲": "鉦",
	"钼": "鉬",
	"钽": "鉭",
	"锎": "鐦",
	"鉴": "鑑",
	"铏": "鉶",
	"铰": "鉸",
	"铒": "鉺",
	"铬": "鉻",
	"铪": "鉿",
	"银": "銀",
	"铳": "銃",
	"铜": "銅",
	"铚": "銍",
	"铣": "銑",
	"铨": "銓",
	"铢": "銖",
	"铭": "銘",
	"铫": "銚",
	"铦": "銛",
	"铑": "銠",
	"铷": "銣",
	"铱": "銥",
	"铟": "銦",
	"铵": "銨",
	"铥": "銩",
	"铕": "銪",
	"铯": "銫",
	"铐": "銬",
	"銮": "鑾",
	"铞": "銱",
	"锐": "銳",
	"销": "銷",
	"锈": "銹",
	"锑": "銻",
	"锉": "銼",
	"铝": "鋁",
	"镅": "鎇",
	"锒": "鋃",
	"锌": "鋅",
	"钡": "鋇",
	"铤": "鋌",
	"铗": "鋏",
	"锋": "鋒",
	"铻": "鋙",
	"镯": "鐲",
	"锊": "鋝",
	"锓": "鋟",
	"铘": "鋣",
	"锃": "鋥",
	"锔": "鋦",
	"锇": "鋨",
	"铓": "鋩",
	"铖": "鋮",
	"锆": "鋯",
	"锂": "鋰",
	"铽": "鋱",
	"锍": "鋶",
	"锯": "鋸",
	"钢": "鋼",
	"锞": "錁",
	"锖": "錆",
	"锫": "錇",
	"锩": "錈",
	"铔": "錏",
	"锥": "錐",
	"锕": "錒",
	"锟": "錕",
	"锤": "錘",
	"锱": "錙",
	"铮": "錚",
	"锛": "錛",
	"锬": "錟",
	"锭": "錠",
	"锜": "錡",
	"钱": "錢",
	"锦": "錦",
	"锚": "錨",
	"锠": "錩",
	"锡": "錫",
	"锢": "錮",
	"错": "錯",
	"锰": "錳",
	"铼": "錸",
	"镎": "鎿",
	"錾": "鏨",
	"锝": "鍀",
	"锨": "鍁",
	"锪": "鍃",
	"钔": "鍆",
	"锴": "鍇",
	"锳": "鍈",
	"锅": "鍋",
	"镀": "鍍",
	"锷": "鍔",
	"铡": "鍘",
	"钖": "鍚",
	"锻": "鍛",
	"锽": "鍠",
	"锸": "鍤",
	"锲": "鍥",
	"锘": "鍩",
	"锹": "鍬",
	"锾": "鍰",
	"键": "鍵",
	"锶": "鍶",
	"锗": "鍺",
	"镁": "鎂",
	"锿": "鎄",
	"镑": "鎊",
	"镕": "鎔",
	"锁": "鎖",
	"镉": "鎘",
	"镈": "鎛",
	"镃": "鎡",
	"钨": "鎢",
	"镏": "鎦",
	"铠": "鎧",
	"铩": "鎩",
	"锼": "鎪",
	"镐": "鎬",
	"镇": "鎮",
	"镒": "鎰",
	"镋": "鎲",
	"镍": "鎳",
	"镓": "鎵",
	"镌": "鎸",
	"镞": "鏃",
	"链": "鏈",
	"镆": "鏌",
	"镙": "鏍",
	"镠": "鏐",
	"镝": "鏑",
	"铿": "鏗",
	"锵": "鏘",
	"镗": "鏜",
	"镘": "鏝",
	"镛": "鏞",
	"镜": "鏡",
	"镖": "鏢",
	"镂": "鏤",
	"镚": "鏰",
	"铧": "鏵",
	"镤": "鏷",
	"镪": "鏹",
	"铙": "鐃",
	"铴": "鐋",
	"镣": "鐐",
	"铹": "鐒",
	"镦": "鐓",
	"镡": "鐔",
	"镫": "鐙",
	"镢": "鐝",
	"镨": "鐠",
	"锏": "鐧",
	"镄": "鐨",
	"镰": "鐮",
	"镭": "鐳",
	"镮": "鐶",
	"铎": "鐸",
	"铛": "鐺",
	"镱": "鐿",
	"铸": "鑄",
	"镬": "鑊",
	"镔": "鑌",
	"镲": "鑔",
	"锧": "鑕",
	"镴": "鑞",
	"铄": "鑠",
	"镳": "鑣",
	"镥": "鑥",
	"镧": "鑭",
	"镵": "鑱",
	"镶": "鑲",
	"镊": "鑷",
	"镩": "鑹",
	"锣": "鑼",
	"锺": "鍾",
	"长": "長",
	"门": "門",
	"闩": "閂",
	"闪": "閃",
	"闫": "閆",
	"闬": "閈",
	"闭": "閉",
	"闶": "閌",
	"闳": "閎",
	"闰": "閏",
	"闲": "閑",
	"间": "間",
	"闵": "閔",
	"闹": "鬧",
	"阂": "閡",
	"阁": "閣",
	"阀": "閥",
	"闺": "閨",
	"闽": "閩",
	"阃": "閫",
	"阆": "閬",
	"闾": "閭",
	"阅": "閱",
	"阊": "閶",
	"阉": "閹",
	"阎": "閻",
	"阏": "閼",
	"阍": "閽",
	"阈": "閾",
	"阌": "閿",
	"阒": "闃",
	"闱": "闈",
	"阕": "闋",
	"阑": "闌",
	"阇": "闍",
	"阗": "闐",
	"阘": "闒",
	"闿": "闓",
	"阖": "闔",
	"阙": "闕",
	"闯": "闖",
	"阚": "闞",
	"阓": "闠",
	"阐": "闡",
	"阛": "闤",
	"闼": "闥",
	"阄": "鬮",
	"阋": "鬩",
	"队": "隊",
	"阳": "陽",
	"阴": "陰",
	"阵": "陣",
	"际": "際",
	"陆": "陸",
	"陇": "隴",
	"陈": "陳",
	"陉": "陘",
	"陕": "陝",
	"陧": "隉",
	"陨": "隕",
	"险": "險",
	"随": "隨",
	"隐": "隱",
	"隶": "隸",
	"隽": "雋",
	"难": "難",
	"雏": "雛",
	"鸡": "雞",
	"雳": "靂",
	"雾": "霧",
	"霁": "霽",
	"霉": "霉",
	"霭": "靄",
	"靓": "靚",
	"静": "靜",
	"靥": "靨",
	"韧": "韌",
	"鼗": "鞀",
	"鞑": "韃",
	"鞒": "鞽",
	"鞯": "韉",
	"鞴": "韝",
	"韦": "韋",
	"韨": "韍",
	"韩": "韓",
	"韪": "韙",
	"韬": "韜",
	"韫": "韞",
	"韵": "韻",
	"页": "頁",
	"顶": "頂",
	"顷": "頃",
	"项": "項",
	"顺": "順",
	"顸": "頇",
	"须": "須",
	"顼": "頊",
	"颂": "頌",
	"颀": "頎",
	"颃": "頏",
	"预": "預",
	"顽": "頑",
	"颁": "頒",
	"顿": "頓",
	"颇": "頗",
	"领": "領",
	"颌": "頜",
	"颉": "頡",
	"颐": "頤",
	"颏": "頦",
	"颒": "頮",
	"颊": "頰",
	"颋": "頲",
	"颕": "頴",
	"颔": "頷",
	"颈": "頸",
	"频": "頻",
	"颗": "顆",
	"题": "題",
	"额": "額",
	"颚": "顎",
	"颜": "顏",
	"颙": "顒",
	"颛": "顓",
	"颡": "顙",
	"颠": "顛",
	"颟": "顢",
	"颢": "顥",
	"顾": "顧",
	"颤": "顫",
	"颥": "顬",
	"颦": "顰",
	"颅": "顱",
	"颞": "顳",
	"颧": "顴",
	"风": "風",
	"飐": "颭",
	"飑": "颮",
	"飒": "颯",
	"飓": "颶",
	"飔": "颸",
	"飖": "颻",
	"飕": "颼",
	"飗": "飀",
	"飘": "飄",
	"飙": "飆",
	"飏": "颺",
	"飚": "飈",
	"飞": "飛",
	"饥": "飢",
	"饤": "飣",
	"饦": "飥",
	"飨": "饗",
	"饨": "飩",
	"饪": "飪",
	"饫": "飫",
	"饬": "飭",
	"饭": "飯",
	"饮": "飲",
	"饴": "飴",
	"饲": "飼",
	"饱": "飽",
	"饰": "飾",
	"饳": "飿",
	"饺": "餃",
	"饸": "餄",
	"饼": "餅",
	"饷": "餉",
	"饵": "餌",
	"餍": "饜",
	"饹": "餎",
	"饻": "餏",
	"饽": "餑",
	"馁": "餒",
	"饿": "餓",
	"馂": "餕",
	"饾": "餖",
	"馄": "餛",
	"馃": "餜",
	"饯": "餞",
	"馅": "餡",
	"饧": "餳",
	"馉": "餶",
	"馇": "餷",
	"馎": "餺",
	"饩": "餼",
	"馈": "饋",
	"馏": "餾",
	"馊": "餿",
	"馌": "饁",
	"馍": "饃",
	"馒": "饅",
	"馐": "饈",
	"馑": "饉",
	"馓": "饊",
	"馔": "饌",
	"饶": "饒",
	"馋": "饞",
	"馕": "饢",
	"馀": "餘",
	"马": "馬",
	"驭": "馭",
	"驮": "馱",
	"驰": "馳",
	"驯": "馴",
	"驲": "馹",
	"驳": "駁",
	"驻": "駐",
	"驽": "駑",
	"驹": "駒",
	"驵": "駔",
	"驾": "駕",
	"骀": "駘",
	"驸": "駙",
	"驶": "駛",
	"驼": "駝",
	"驷": "駟",
	"骈": "駢",
	"骇": "駭",
	"骃": "駰",
	"骆": "駱",
	"骎": "駸",
	"骏": "駿",
	"骋": "騁",
	"骍": "騂",
	"骓": "騅",
	"骔": "騌",
	"骒": "騍",
	"骑": "騎",
	"骐": "騏",
	"验": "驗",
	"骛": "騖",
	"骗": "騙",
	"骙": "騤",
	"骞": "騫",
	"骘": "騭",
	"骝": "騮",
	"驺": "騶",
	"骚": "騷",
	"骟": "騸",
	"骡": "騾",
	"骜": "驁",
	"骖": "驂",
	"骠": "驃",
	"骢": "驄",
	"骅": "驊",
	"骕": "驌",
	"骁": "驍",
	"骣": "驏",
	"骄": "驕",
	"驿": "驛",
	"骤": "驟",
	"驴": "驢",
	"骧": "驤",
	"骥": "驥",
	"骦": "驦",
	"骊": "驪",
	"骉": "驫",
	"鲠": "鯁",
	"髅": "髏",
	"髋": "髖",
	"髌": "髕",
	"鬓": "鬢",
	"魇": "魘",
	"魉": "魎",
	"鱼": "魚",
	"鱽": "魛",
	"鱾": "魢",
	"鲀": "魨",
	"鲁": "魯",
	"鲂": "魴",
	"鱿": "魷",
	"鲄": "魺",
	"鲅": "鮁",
	"鲆": "鮃",
	"鲌": "鮊",
	"鲉": "鮋",
	"鲧": "鯀",
	"鲏": "鮍",
	"鲇": "鮎",
	"鲐": "鮐",
	"鲍": "鮑",
	"鲋": "鮒",
	"鲊": "鮓",
	"鲒": "鮚",
	"鲘": "鮜",
	"鲕": "鮞",
	"鲖": "鮦",
	"鲔": "鮪",
	"鲛": "鮫",
	"鲑": "鮭",
	"鲜": "鮮",
	"鲓": "鮳",
	"鲪": "鮶",
	"鳀": "鯷",
	"鲝": "鮺",
	"鲩": "鯇",
	"鲤": "鯉",
	"鲨": "鯊",
	"鲬": "鯒",
	"鲻": "鯔",
	"鲯": "鯕",
	"鲭": "鯖",
	"鲞": "鯗",
	"鲷": "鯛",
	"鲴": "鯝",
	"鲱": "鯡",
	"鲵": "鯢",
	"鲲": "鯤",
	"鲳": "鯧",
	"鲸": "鯨",
	"鲮": "鯪",
	"鲰": "鯫",
	"鲶": "鯰",
	"鲺": "鯴",
	"鲹": "鰺",
	"鲫": "鯽",
	"鳊": "鯿",
	"鳈": "鰁",
	"鲗": "鰂",
	"鳂": "鰃",
	"鲽": "鰈",
	"鳇": "鰉",
	"鳅": "鰍",
	"鲾": "鰏",
	"鳄": "鱷",
	"鳆": "鰒",
	"鳃": "鰓",
	"鳁": "鰮",
	"鳒": "鰜",
	"鳑": "鰟",
	"鳋": "鰠",
	"鲥": "鰣",
	"鳏": "鰥",
	"鳎": "鰨",
	"鳐": "鰩",
	"鳍": "鰭",
	"鲢": "鰱",
	"鳌": "鰲",
	"鳓": "鰳",
	"鳘": "鰵",
	"鲦": "鰷",
	"鲣": "鰹",
	"鳗": "鰻",
	"鳛": "鰼",
	"鳔": "鰾",
	"鳉": "鱂",
	"鳙": "鱅",
	"鳕": "鱈",
	"鳖": "鱉",
	"鳟": "鱒",
	"鳝": "鱔",
	"鳜": "鱖",
	"鳞": "鱗",
	"鲟": "鱘",
	"鲼": "鱝",
	"鲎": "鱟",
	"鲙": "鱠",
	"鳣": "鱣",
	"鳡": "鱤",
	"鳢": "鱧",
	"鲿": "鱨",
	"鲚": "鱭",
	"鳠": "鱯",
	"鲈": "鱸",
	"鲡": "鱺",
	"鸟": "鳥",
	"鸠": "鳩",
	"鸤": "鳲",
	"鸣": "鳴",
	"鸢": "鳶",
	"鸩": "鴆",
	"鸨": "鴇",
	"鸦": "鴉",
	"鸰": "鴒",
	"鸵": "鴕",
	"鸳": "鴛",
	"鸲": "鴝",
	"鸮": "鴞",
	"鸱": "鴟",
	"鸪": "鴣",
	"鸯": "鴦",
	"鸭": "鴨",
	"鸴": "鷽",
	"鸸": "鴯",
	"鸹": "鴰",
	"鸻": "鴴",
	"鸿": "鴻",
	"鸽": "鴿",
	"鸺": "鵂",
	"鸼": "鵃",
	"鹀": "鵐",
	"鹃": "鵑",
	"鹆": "鵒",
	"鹁": "鵓",
	"鹈": "鵜",
	"鹅": "鵝",
	"鹄": "鵠",
	"鹉": "鵡",
	"鹌": "鵪",
	"鹏": "鵬",
	"鹐": "鵮",
	"鹎": "鵯",
	"鹊": "鵲",
	"鹓": "鵷",
	"鹍": "鵾",
	"鸫": "鶇",
	"鹑": "鶉",
	"鹒": "鶊",
	"鹋": "鶓",
	"鹙": "鶖",
	"鹕": "鶘",
	"鹗": "鶚",
	"鹖": "鶡",
	"鹛": "鶥",
	"鹜": "鶩",
	"鸧": "鶬",
	"鹟": "鶲",
	"鹤": "鶴",
	"鹠": "鶹",
	"鹡": "鶺",
	"鹘": "鶻",
	"鹣": "鶼",
	"鹚": "鶿",
	"鹢": "鷁",
	"鹞": "鷂",
	"鹝": "鷊",
	"鹧": "鷓",
	"鹥": "鷖",
	"鸥": "鷗",
	"鸷": "鷙",
	"鹨": "鷚",
	"鸶": "鷥",
	"鹪": "鷦",
	"鹔": "鷫",
	"鹩": "鷯",
	"鹫": "鷲",
	"鹇": "鷳",
	"鹬": "鷸",
	"鹰": "鷹",
	"鹭": "鷺",
	"鹯": "鸇",
	"鹱": "鸌",
	"鹲": "鸏",
	"鸬": "鸕",
	"鹴": "鸘",
	"鹦": "鸚",
	"鹳": "鸛",
	"鹂": "鸝",
	"鸾": "鸞",
	"鹾": "鹺",
	"麦": "麥",
	"麸": "麩",
	"黄": "黃",
	"黉": "黌",
	"黡": "黶",
	"黩": "黷",
	"黪": "黲",
	"黾": "黽",
	"鼋": "黿",
	"鼌": "鼂",
	"鼍": "鼉",
	"鼹": "鼴",
	"齄": "齇",
	"齐": "齊",
	"齑": "齏",
	"齿": "齒",
	"龀": "齔",
	"龁": "齕",
	"龂": "齗",
	"龅": "齙",
	"龇": "齜",
	"龃": "齟",
	"龆": "齠",
	"龄": "齡",
	"龈": "齦",
	"龊": "齪",
	"龉": "齬",
	"龋": "齲",
	"龌": "齷",
	"龙": "龍",
	"龚": "龔",
	"龛": "龕",
	"龟": "龜",
	"䌶": "䊷",
	"䜥": "𧩙",
	"伣": "俔",
	"俫": "倈",
	"刹": "剎",
	"厐": "龎",
	"厘": "釐",
	"呐": "吶",
	"㖞": "喎",
	"𡒄": "壈",
	"姹": "奼",
	"弑": "弒",
	"彝": "彞",
	"恒": "恆",
	"悮": "悞",
	"戯": "戱",
	"挽": "挽",
	"捝": "挩",
	"揾": "搵",
	"㧑": "撝",
	"㧟": "擓",
	"杆": "桿",
	"栗": "栗",
	"梿": "槤",
	"棁": "梲",
	"榅": "榲",
	"㱮": "殨",
	"灶": "灶",
	"煴": "熅",
	"疭": "瘲",
	"䁖": "瞜",
	"祃": "禡",
	"窎": "窵",
	"䇲": "筴",
	"筼": "篔",
	"䌷": "紬",
	"䌹": "絅",
	"䌸": "縳",
	"䍁": "繸",
	"肮": "骯",
	"肴": "餚",
	"蔂": "虆",
	"蕰": "薀",
	"蘖": "櫱",
	"訚": "誾",
	"䜣": "訢",
	"讬": "託",
	"酂": "酇",
	"钅": "釒",
	"钜": "鉅",
	"铇": "鉋",
	"镟": "鏇",
	"霡": "霢",
	"饣": "飠",
	"鲃": "䰾",
	"鳚": "䲁",
	"䴓": "鳾",
	"䴕": "鴷",
	"䴔": "鵁",
	"䴖": "鶄",
	"䴗": "鶪",
	"䴘": "鷈",
	"䴙": "鷿",
	"麽": "麼",
	"后": "後",
	"凃": "塗",
	"㑩": "儸",
	"准": "準",
	"𫔀": "鍊",
	"面": "麵",
	"舍": "捨",
	"松": "鬆",
	"𫔮": "閒",
	"痳": "痲",
	"占": "佔",
	"借": "藉",
	"制": "製",
	"征": "徵",
	"喂": "餵",
	"只": "隻",
	"炮": "砲",
	"奸": "姦",
	"困": "睏",
	"志": "誌",
	"布": "佈",
	"系": "繫",
	"分": "份",
	"梁": "樑",
	"䌽": "綵",
	"板": "闆",
	"注": "註",
	"克": "剋",
	"唇": "唇",
	"𪸩": "煇",
	"𫗭": "餵",
	"𫗪": "餧",
	"鹹": "咸",
	"刬": "剗",
	"铲": "鏟",
	"采": "採",
	"昵": "暱",
	"𫄤": "繨",
	"㓥": "劏",
	"㳽": "瀰",
	"𫔇": "鎞",
	"汙": "汙",
	"遊": "遊",
	"夥": "夥",
	"哢": "哢",
	"淩": "淩",
	"紮": "紮",
	"癡": "癡",
	"薑": "薑",
	"扡": "扡",
	"撚": "撚",
	"遝": "遝",
	"竈": "竈",
	"黴": "黴",
	"欲": "欲",
	"慾": "慾",
	"讚": "讚",
	"菸": "菸",
	"拾": "拾",
	"十": "十",
	"証": "証",
	"捲": "捲",
	"卷": "卷",
	"燻": "燻",
	"熏": "熏",
	"籲": "籲",
	"龥": "龥",
	"蹠": "蹠",
	"矽": "矽",
	"脩": "脩",
	"修": "修",
	"剷": "剷",
	"劈": "劈",
	"擗": "擗",
	"核": "核",
	"覈": "覈",
	"呼": "呼",
	"呵": "呵",
	"脣": "脣",
	"升": "升",
	"昇": "昇",
	"磐": "磐",
	"溪": "溪",
	"渓": "渓",
	"谿": "谿",
	"嵠": "嵠",
	"祐": "祐",
	"佑": "佑",
	"媮": "媮",
	"偷": "偷",
	"罋": "罋",
	"甕": "甕",
	"闇": "闇",
	"暗": "暗",
	"痺": "痺",
	"痹": "痹",
	"雇": "雇",
	"僱": "僱",
	"秘": "秘",
	"祕": "祕",
	"周": "周",
	"週": "週",
	"闢": "闢",
	"簷": "簷",
	"湧": "湧",
	"家": "家",
	"傢": "傢",
	"亙": "亙",
	"洩": "洩",
	"泄": "泄",
	"珮": "珮",
	"佩": "佩",
	"尅": "尅",
	"剿": "剿",
	"勦": "勦",
	"沉": "沉",
	"沈": "沈",
	"搾": "搾",
	"榨": "榨",
	"筱": "筱",
	"篠": "篠",
	"陞": "陞",
	"獃": "獃",
	"盃": "盃",
	"牋": "牋",
	"竝": "竝",
	"弔": "弔",
	"徬": "徬",
	"彷": "彷",
	"喦": "喦",
	"巖": "巖",
	"岩": "岩",
	"劄": "劄",
	"噪": "噪",
	"譟": "譟",
	"彫": "彫",
	"雕": "雕",
	"衊": "衊",
	"蔑": "蔑",
	"蒙": "蒙",
	"濛": "濛",
	"矇": "矇",
	"懞": "懞",
	"啣": "啣",
	"嫺": "嫺",
	"鞦": "鞦",
	"鬨": "鬨",
	"譁": "譁",
	"箇": "箇",
	"猛": "猛",
	"薰": "薰",
	"暨": "暨",
};

export const table_tw2cn: ITable = {
	"萬": "万",
	"與": "与",
	"醜": "丑",
	"專": "专",
	"業": "业",
	"叢": "丛",
	"東": "东",
	"絲": "丝",
	"丟": "丢",
	"兩": "两",
	"嚴": "严",
	"並": "并",
	"喪": "丧",
	"個": "个",
	"爿": "丬",
	"豐": "丰",
	"臨": "临",
	"為": "为",
	"麗": "丽",
	"舉": "举",
	"麼": "么",
	"義": "义",
	"烏": "乌",
	"樂": "乐",
	"喬": "乔",
	"習": "习",
	"鄉": "乡",
	"書": "书",
	"買": "买",
	"亂": "乱",
	"乾": "干",
	"爭": "争",
	"於": "于",
	"虧": "亏",
	"雲": "云",
	"亙": "亙",
	"亞": "亚",
	"產": "产",
	"畝": "亩",
	"親": "亲",
	"褻": "亵",
	"嚲": "亸",
	"億": "亿",
	"僅": "仅",
	"僕": "仆",
	"從": "从",
	"侖": "仑",
	"倉": "仓",
	"儀": "仪",
	"們": "们",
	"價": "价",
	"伕": "夫",
	"眾": "众",
	"優": "优",
	"夥": "夥",
	"會": "会",
	"傴": "伛",
	"傘": "伞",
	"偉": "伟",
	"傳": "传",
	"傷": "伤",
	"倀": "伥",
	"倫": "伦",
	"傖": "伧",
	"偽": "伪",
	"佇": "伫",
	"佈": "布",
	"體": "体",
	"佔": "占",
	"佘": "佘",
	"餘": "馀",
	"傭": "佣",
	"僉": "佥",
	"併": "并",
	"來": "来",
	"俠": "侠",
	"侶": "侣",
	"僥": "侥",
	"偵": "侦",
	"側": "侧",
	"僑": "侨",
	"儈": "侩",
	"儕": "侪",
	"儂": "侬",
	"侷": "局",
	"俁": "俣",
	"係": "系",
	"儔": "俦",
	"儼": "俨",
	"倆": "俩",
	"儷": "俪",
	"儉": "俭",
	"倖": "幸",
	"倣": "仿",
	"債": "债",
	"傾": "倾",
	"傯": "偬",
	"偸": "偷",
	"偺": "咱",
	"僂": "偻",
	"僨": "偾",
	"償": "偿",
	"傑": "杰",
	"備": "备",
	"傚": "效",
	"傢": "傢",
	"儻": "傥",
	"儐": "傧",
	"儲": "储",
	"儺": "傩",
	"僞": "伪",
	"僱": "僱",
	"儅": "儅",
	"儘": "尽",
	"儸": "㑩",
	"儹": "攒",
	"兒": "儿",
	"兇": "凶",
	"兌": "兑",
	"兗": "兖",
	"黨": "党",
	"內": "内",
	"蘭": "兰",
	"關": "关",
	"興": "兴",
	"茲": "兹",
	"養": "养",
	"獸": "兽",
	"囅": "冁",
	"岡": "冈",
	"冊": "册",
	"寫": "写",
	"軍": "军",
	"農": "农",
	"塚": "冢",
	"冪": "幂",
	"馮": "冯",
	"沖": "冲",
	"決": "决",
	"況": "况",
	"凍": "冻",
	"淨": "净",
	"凃": "涂",
	"淒": "凄",
	"涼": "凉",
	"淩": "淩",
	"減": "减",
	"湊": "凑",
	"凜": "凛",
	"凟": "渎",
	"幾": "几",
	"鳳": "凤",
	"処": "处",
	"鳧": "凫",
	"憑": "凭",
	"凱": "凯",
	"凴": "凭",
	"擊": "击",
	"鑿": "凿",
	"芻": "刍",
	"劃": "划",
	"劉": "刘",
	"則": "则",
	"剛": "刚",
	"創": "创",
	"刪": "删",
	"別": "别",
	"剄": "刭",
	"劊": "刽",
	"劌": "刿",
	"剴": "剀",
	"劑": "剂",
	"剋": "克",
	"剮": "剐",
	"劍": "剑",
	"剝": "剥",
	"劇": "剧",
	"劄": "劄",
	"劒": "剑",
	"勸": "劝",
	"辦": "办",
	"務": "务",
	"勱": "劢",
	"動": "动",
	"勵": "励",
	"勁": "劲",
	"勞": "劳",
	"勢": "势",
	"勳": "勋",
	"勗": "勖",
	"勩": "勚",
	"勛": "勋",
	"勝": "胜",
	"勣": "绩",
	"勦": "勦",
	"勻": "匀",
	"匭": "匦",
	"匱": "匮",
	"匯": "汇",
	"匲": "奁",
	"匳": "奁",
	"匵": "椟",
	"區": "区",
	"醫": "医",
	"華": "华",
	"協": "协",
	"單": "单",
	"賣": "卖",
	"蔔": "卜",
	"盧": "卢",
	"鹵": "卤",
	"臥": "卧",
	"衛": "卫",
	"卻": "却",
	"卹": "恤",
	"巹": "卺",
	"廠": "厂",
	"廳": "厅",
	"曆": "历",
	"厲": "厉",
	"壓": "压",
	"厭": "厌",
	"厙": "厍",
	"廁": "厕",
	"厛": "厅",
	"厠": "厕",
	"廂": "厢",
	"厴": "厣",
	"厤": "历",
	"廈": "厦",
	"廚": "厨",
	"廄": "厩",
	"廝": "厮",
	"厰": "厂",
	"縣": "县",
	"參": "参",
	"靉": "叆",
	"靆": "叇",
	"雙": "双",
	"發": "发",
	"變": "变",
	"敘": "叙",
	"疊": "叠",
	"葉": "叶",
	"號": "号",
	"歎": "叹",
	"嘰": "叽",
	"籲": "籲",
	"吒": "吒",
	"嚇": "吓",
	"呂": "吕",
	"嗎": "吗",
	"唚": "吣",
	"噸": "噸",
	"聽": "听",
	"啟": "启",
	"吳": "吴",
	"嘸": "呒",
	"囈": "呓",
	"嘔": "呕",
	"嚦": "呖",
	"唄": "呗",
	"員": "员",
	"咼": "呙",
	"嗆": "呛",
	"嗚": "呜",
	"詠": "咏",
	"哢": "哢",
	"嚨": "咙",
	"嚀": "咛",
	"噝": "咝",
	"諮": "谘",
	"噅": "咴",
	"鹹": "咸",
	"響": "响",
	"啞": "哑",
	"噠": "哒",
	"嘵": "哓",
	"嗶": "哔",
	"噦": "哕",
	"嘩": "哗",
	"噲": "哙",
	"嚌": "哜",
	"噥": "哝",
	"喲": "哟",
	"唕": "唣",
	"嘜": "唛",
	"嗊": "唝",
	"嘮": "唠",
	"啢": "唡",
	"嗩": "唢",
	"喚": "唤",
	"唸": "念",
	"問": "问",
	"啓": "启",
	"啗": "啖",
	"啣": "啣",
	"嘖": "啧",
	"嗇": "啬",
	"囀": "啭",
	"齧": "啮",
	"囉": "啰",
	"嘽": "啴",
	"嘯": "啸",
	"喒": "咱",
	"喦": "喦",
	"喫": "吃",
	"噴": "喷",
	"嘍": "喽",
	"嚳": "喾",
	"囁": "嗫",
	"噯": "嗳",
	"嘆": "叹",
	"嘗": "尝",
	"噓": "嘘",
	"嚶": "嘤",
	"囑": "嘱",
	"噁": "恶",
	"嚕": "噜",
	"噹": "当",
	"嚐": "尝",
	"嚙": "啮",
	"囂": "嚣",
	"嚥": "咽",
	"嚮": "向",
	"謔": "谑",
	"嚻": "嚣",
	"囌": "苏",
	"囘": "回",
	"團": "团",
	"囪": "囱",
	"囬": "回",
	"園": "园",
	"囯": "国",
	"圍": "围",
	"圇": "囵",
	"國": "国",
	"圖": "图",
	"圓": "圆",
	"聖": "圣",
	"壙": "圹",
	"場": "场",
	"壞": "坏",
	"塊": "块",
	"堅": "坚",
	"壇": "坛",
	"壢": "坜",
	"壩": "坝",
	"塢": "坞",
	"墳": "坟",
	"墜": "坠",
	"坰": "垧",
	"壟": "垄",
	"壚": "垆",
	"壘": "垒",
	"墾": "垦",
	"堊": "垩",
	"墊": "垫",
	"埡": "垭",
	"墶": "垯",
	"壋": "垱",
	"塏": "垲",
	"堖": "垴",
	"垵": "埯",
	"垻": "坝",
	"塒": "埘",
	"塤": "埙",
	"堝": "埚",
	"埰": "采",
	"執": "执",
	"塹": "堑",
	"墮": "堕",
	"堦": "阶",
	"堯": "尧",
	"報": "报",
	"堿": "碱",
	"壪": "塆",
	"塋": "茔",
	"塗": "凃",
	"塲": "场",
	"塵": "尘",
	"塼": "砖",
	"牆": "墙",
	"墝": "硗",
	"墰": "坛",
	"墻": "墙",
	"壎": "埙",
	"壜": "坛",
	"壠": "垅",
	"壯": "壮",
	"聲": "声",
	"殼": "壳",
	"壺": "壶",
	"壼": "壸",
	"壽": "寿",
	"夀": "寿",
	"處": "处",
	"複": "复",
	"夠": "够",
	"夢": "梦",
	"頭": "头",
	"誇": "夸",
	"夾": "夹",
	"奪": "夺",
	"奩": "奁",
	"奐": "奂",
	"奮": "奋",
	"獎": "奖",
	"奧": "奥",
	"妝": "妆",
	"婦": "妇",
	"媽": "妈",
	"嫵": "妩",
	"嫗": "妪",
	"媯": "妫",
	"姍": "姗",
	"薑": "薑",
	"姦": "奸",
	"姪": "侄",
	"婁": "娄",
	"婭": "娅",
	"嬈": "娆",
	"嬌": "娇",
	"孌": "娈",
	"娛": "娱",
	"娬": "妩",
	"媧": "娲",
	"嫻": "娴",
	"婬": "淫",
	"嫿": "婳",
	"嬰": "婴",
	"嬋": "婵",
	"嬸": "婶",
	"媼": "媪",
	"媮": "媮",
	"嫋": "袅",
	"嬡": "嫒",
	"嬪": "嫔",
	"嬙": "嫱",
	"嫺": "嫺",
	"嬀": "妫",
	"嬝": "袅",
	"嬤": "嬷",
	"嬭": "奶",
	"嬾": "懒",
	"孃": "娘",
	"孫": "孙",
	"學": "学",
	"孿": "孪",
	"寧": "宁",
	"寶": "宝",
	"實": "实",
	"寵": "宠",
	"審": "审",
	"憲": "宪",
	"宮": "宫",
	"寬": "宽",
	"賓": "宾",
	"寢": "寝",
	"對": "对",
	"尋": "寻",
	"導": "导",
	"尅": "尅",
	"將": "将",
	"爾": "尔",
	"尲": "尴",
	"尷": "尴",
	"屍": "尸",
	"盡": "尽",
	"層": "层",
	"屭": "屃",
	"屆": "届",
	"屜": "屉",
	"屓": "屃",
	"屬": "属",
	"屢": "屡",
	"屨": "屦",
	"嶼": "屿",
	"歲": "岁",
	"豈": "岂",
	"嶇": "岖",
	"崗": "岗",
	"峴": "岘",
	"嶴": "岙",
	"嵐": "岚",
	"島": "岛",
	"嶺": "岭",
	"嶽": "岳",
	"崠": "岽",
	"巋": "岿",
	"嶨": "峃",
	"嶧": "峄",
	"峽": "峡",
	"嶢": "峣",
	"嶠": "峤",
	"崢": "峥",
	"巒": "峦",
	"嶗": "崂",
	"崍": "崃",
	"嶮": "崄",
	"崐": "昆",
	"崑": "昆",
	"崙": "仑",
	"崬": "岽",
	"嶄": "崭",
	"崳": "嵛",
	"嵗": "岁",
	"嶸": "嵘",
	"嶔": "嵚",
	"嶁": "嵝",
	"巔": "巅",
	"巖": "巖",
	"鞏": "巩",
	"巰": "巯",
	"幣": "币",
	"帥": "帅",
	"師": "师",
	"幃": "帏",
	"帳": "帐",
	"簾": "帘",
	"幟": "帜",
	"帶": "带",
	"幀": "帧",
	"幫": "帮",
	"幬": "帱",
	"幘": "帻",
	"幗": "帼",
	"襆": "幞",
	"幱": "襕",
	"幹": "干",
	"廣": "广",
	"莊": "庄",
	"慶": "庆",
	"廬": "庐",
	"廡": "庑",
	"庫": "库",
	"應": "应",
	"廟": "庙",
	"龐": "庞",
	"廢": "废",
	"廎": "庼",
	"廕": "荫",
	"廩": "廪",
	"廻": "回",
	"廼": "乃",
	"開": "开",
	"異": "异",
	"棄": "弃",
	"弔": "弔",
	"張": "张",
	"彌": "弥",
	"弳": "弪",
	"彎": "弯",
	"強": "强",
	"彈": "弹",
	"彆": "别",
	"彊": "强",
	"歸": "归",
	"當": "当",
	"錄": "录",
	"彙": "汇",
	"彜": "彝",
	"彞": "彝",
	"彠": "彟",
	"彥": "彦",
	"彫": "彫",
	"徹": "彻",
	"彿": "佛",
	"徑": "径",
	"徠": "徕",
	"禦": "御",
	"復": "复",
	"徬": "徬",
	"徴": "征",
	"徵": "征",
	"憶": "忆",
	"懺": "忏",
	"憂": "忧",
	"愾": "忾",
	"懷": "怀",
	"態": "态",
	"慫": "怂",
	"憮": "怃",
	"慪": "怄",
	"悵": "怅",
	"愴": "怆",
	"憐": "怜",
	"總": "总",
	"懟": "怼",
	"懌": "怿",
	"恆": "恒",
	"戀": "恋",
	"恥": "耻",
	"懇": "恳",
	"惡": "恶",
	"慟": "恸",
	"懨": "恹",
	"愷": "恺",
	"惻": "恻",
	"惱": "恼",
	"惲": "恽",
	"悅": "悦",
	"愨": "悫",
	"懸": "悬",
	"慳": "悭",
	"憫": "悯",
	"悶": "闷",
	"悽": "悽",
	"驚": "惊",
	"懼": "惧",
	"慘": "惨",
	"懲": "惩",
	"憊": "惫",
	"愜": "惬",
	"慚": "惭",
	"憚": "惮",
	"慣": "惯",
	"湣": "愍",
	"愛": "爱",
	"慍": "愠",
	"憤": "愤",
	"憒": "愦",
	"願": "愿",
	"慄": "栗",
	"慇": "殷",
	"懾": "慑",
	"慙": "惭",
	"慤": "悫",
	"憖": "慭",
	"慮": "虑",
	"慴": "慑",
	"慼": "戚",
	"慾": "慾",
	"懍": "懔",
	"懣": "懑",
	"懶": "懒",
	"懕": "恹",
	"懞": "懞",
	"懽": "欢",
	"戇": "戆",
	"戔": "戋",
	"戲": "戏",
	"戧": "戗",
	"戰": "战",
	"戩": "戬",
	"戯": "戏",
	"戶": "户",
	"紮": "紮",
	"撲": "扑",
	"扡": "扡",
	"擴": "扩",
	"捫": "扪",
	"掃": "扫",
	"揚": "扬",
	"擾": "扰",
	"撫": "抚",
	"拋": "抛",
	"摶": "抟",
	"摳": "抠",
	"掄": "抡",
	"搶": "抢",
	"護": "护",
	"擔": "担",
	"擬": "拟",
	"攏": "拢",
	"揀": "拣",
	"擁": "拥",
	"攔": "拦",
	"擰": "拧",
	"撥": "拨",
	"擇": "择",
	"掛": "挂",
	"摯": "挚",
	"攣": "挛",
	"掗": "挜",
	"撾": "挝",
	"撻": "挞",
	"挾": "挟",
	"撓": "挠",
	"擋": "挡",
	"撟": "挢",
	"掙": "挣",
	"擠": "挤",
	"揮": "挥",
	"撏": "挦",
	"撈": "捞",
	"損": "损",
	"撿": "捡",
	"換": "换",
	"搗": "捣",
	"捨": "舍",
	"據": "据",
	"捲": "捲",
	"撚": "撚",
	"採": "采",
	"擄": "掳",
	"摑": "掴",
	"擲": "掷",
	"撣": "掸",
	"摻": "掺",
	"摜": "掼",
	"摣": "揸",
	"揹": "背",
	"攬": "揽",
	"撳": "揿",
	"攙": "搀",
	"擱": "搁",
	"摟": "搂",
	"攪": "搅",
	"搆": "构",
	"搇": "揿",
	"搖": "摇",
	"攜": "携",
	"搾": "搾",
	"攝": "摄",
	"攄": "摅",
	"擺": "摆",
	"擯": "摈",
	"攤": "摊",
	"摺": "折",
	"攖": "撄",
	"撐": "撑",
	"攆": "撵",
	"擷": "撷",
	"擼": "撸",
	"攛": "撺",
	"擕": "携",
	"擻": "擞",
	"擡": "抬",
	"擣": "捣",
	"擧": "举",
	"攢": "攒",
	"攩": "挡",
	"攷": "考",
	"敵": "敌",
	"敍": "叙",
	"敗": "败",
	"斂": "敛",
	"敭": "扬",
	"數": "数",
	"敺": "驱",
	"斃": "毙",
	"齋": "斋",
	"斕": "斓",
	"鬥": "斗",
	"斬": "斩",
	"斷": "断",
	"旂": "旗",
	"無": "无",
	"舊": "旧",
	"時": "时",
	"曠": "旷",
	"暘": "旸",
	"昇": "昇",
	"曇": "昙",
	"晝": "昼",
	"曨": "昽",
	"顯": "显",
	"晉": "晋",
	"曬": "晒",
	"曉": "晓",
	"曄": "晔",
	"暈": "晕",
	"暉": "晖",
	"暫": "暂",
	"暢": "畅",
	"曖": "暧",
	"暱": "昵",
	"曏": "向",
	"曡": "叠",
	"朧": "胧",
	"術": "术",
	"樸": "朴",
	"機": "机",
	"殺": "杀",
	"雜": "杂",
	"權": "权",
	"條": "条",
	"楊": "杨",
	"榪": "杩",
	"極": "极",
	"構": "构",
	"樅": "枞",
	"樞": "枢",
	"棗": "枣",
	"櫪": "枥",
	"梘": "枧",
	"棖": "枨",
	"槍": "枪",
	"楓": "枫",
	"梟": "枭",
	"枴": "拐",
	"櫃": "柜",
	"檸": "柠",
	"柵": "栅",
	"柺": "拐",
	"檉": "柽",
	"梔": "栀",
	"標": "标",
	"棧": "栈",
	"櫛": "栉",
	"櫳": "栊",
	"棟": "栋",
	"櫨": "栌",
	"櫟": "栎",
	"欄": "栏",
	"樹": "树",
	"棲": "栖",
	"樣": "样",
	"欒": "栾",
	"棬": "桊",
	"椏": "桠",
	"橈": "桡",
	"楨": "桢",
	"榿": "桤",
	"橋": "桥",
	"樺": "桦",
	"檜": "桧",
	"槳": "桨",
	"樁": "桩",
	"桿": "杆",
	"梱": "捆",
	"檮": "梼",
	"棶": "梾",
	"檢": "检",
	"欞": "棂",
	"槨": "椁",
	"櫝": "椟",
	"槧": "椠",
	"欏": "椤",
	"橢": "椭",
	"樓": "楼",
	"欖": "榄",
	"櫬": "榇",
	"櫚": "榈",
	"櫸": "榉",
	"榦": "干",
	"榮": "荣",
	"槃": "盘",
	"槓": "杠",
	"檟": "槚",
	"檻": "槛",
	"檳": "槟",
	"櫧": "槠",
	"槼": "规",
	"樑": "梁",
	"橫": "横",
	"檣": "樯",
	"櫻": "樱",
	"樷": "丛",
	"櫫": "橥",
	"橰": "槔",
	"櫥": "橱",
	"櫓": "橹",
	"櫞": "橼",
	"檁": "檩",
	"簷": "簷",
	"檯": "台",
	"檾": "苘",
	"櫂": "棹",
	"櫺": "棂",
	"欑": "攒",
	"歡": "欢",
	"歟": "欤",
	"歐": "欧",
	"欽": "钦",
	"歗": "啸",
	"歛": "敛",
	"歷": "历",
	"殲": "歼",
	"歿": "殁",
	"殤": "殇",
	"殘": "残",
	"殞": "殒",
	"殮": "殓",
	"殫": "殚",
	"殯": "殡",
	"毆": "殴",
	"毀": "毁",
	"轂": "毂",
	"毉": "医",
	"畢": "毕",
	"氈": "毡",
	"毧": "绒",
	"毬": "球",
	"毿": "毵",
	"氂": "牦",
	"氌": "氇",
	"氊": "毡",
	"氣": "气",
	"氫": "氢",
	"氬": "氩",
	"氳": "氲",
	"氾": "泛",
	"漢": "汉",
	"汎": "泛",
	"汙": "汙",
	"汚": "污",
	"湯": "汤",
	"洶": "汹",
	"沍": "冱",
	"沒": "没",
	"遝": "遝",
	"溝": "沟",
	"灃": "沣",
	"漚": "沤",
	"瀝": "沥",
	"淪": "沦",
	"滄": "沧",
	"渢": "沨",
	"溈": "沩",
	"滬": "沪",
	"濔": "沵",
	"濘": "泞",
	"淚": "泪",
	"澩": "泶",
	"瀧": "泷",
	"瀘": "泸",
	"濼": "泺",
	"瀉": "泻",
	"潑": "泼",
	"澤": "泽",
	"涇": "泾",
	"潔": "洁",
	"灑": "洒",
	"洩": "洩",
	"窪": "洼",
	"浹": "浃",
	"淺": "浅",
	"漿": "浆",
	"澆": "浇",
	"湞": "浈",
	"溮": "浉",
	"濁": "浊",
	"測": "测",
	"澮": "浍",
	"濟": "济",
	"瀏": "浏",
	"滻": "浐",
	"渾": "浑",
	"滸": "浒",
	"濃": "浓",
	"潯": "浔",
	"濜": "浕",
	"湧": "湧",
	"涖": "莅",
	"濤": "涛",
	"澇": "涝",
	"淶": "涞",
	"漣": "涟",
	"潿": "涠",
	"渦": "涡",
	"溳": "涢",
	"渙": "涣",
	"滌": "涤",
	"潤": "润",
	"澗": "涧",
	"漲": "涨",
	"澀": "涩",
	"澱": "淀",
	"淥": "渌",
	"淵": "渊",
	"漬": "渍",
	"瀆": "渎",
	"漸": "渐",
	"澠": "渑",
	"漁": "渔",
	"瀋": "沈",
	"滲": "渗",
	"溫": "温",
	"遊": "遊",
	"灣": "湾",
	"濕": "湿",
	"潰": "溃",
	"濺": "溅",
	"漵": "溆",
	"漊": "溇",
	"準": "准",
	"溼": "湿",
	"滅": "灭",
	"滎": "荥",
	"潷": "滗",
	"滙": "汇",
	"滾": "滚",
	"滯": "滞",
	"灩": "滟",
	"灄": "滠",
	"滿": "满",
	"瀅": "滢",
	"濾": "滤",
	"濫": "滥",
	"灤": "滦",
	"濱": "滨",
	"灘": "滩",
	"澦": "滪",
	"滷": "卤",
	"潁": "颍",
	"瀠": "潆",
	"瀟": "潇",
	"瀲": "潋",
	"濰": "潍",
	"潙": "沩",
	"潛": "潜",
	"潟": "舄",
	"瀦": "潴",
	"澁": "涩",
	"澂": "澄",
	"瀾": "澜",
	"瀨": "濑",
	"瀕": "濒",
	"濛": "濛",
	"濬": "浚",
	"濶": "阔",
	"瀰": "㳽",
	"灝": "灏",
	"灕": "漓",
	"灧": "滟",
	"燈": "灯",
	"靈": "灵",
	"災": "灾",
	"燦": "灿",
	"煬": "炀",
	"爐": "炉",
	"燉": "炖",
	"煒": "炜",
	"熗": "炝",
	"炤": "照",
	"點": "点",
	"煉": "炼",
	"熾": "炽",
	"爍": "烁",
	"爛": "烂",
	"烴": "烃",
	"燭": "烛",
	"煙": "烟",
	"煩": "烦",
	"燒": "烧",
	"燁": "烨",
	"燴": "烩",
	"燙": "烫",
	"燼": "烬",
	"熱": "热",
	"煥": "焕",
	"燜": "焖",
	"燾": "焘",
	"煆": "煅",
	"煖": "暖",
	"煢": "茕",
	"熒": "荧",
	"熲": "颎",
	"燄": "焰",
	"燐": "磷",
	"營": "营",
	"燬": "毁",
	"燻": "燻",
	"燿": "耀",
	"爗": "烨",
	"爲": "为",
	"爺": "爷",
	"牀": "床",
	"牋": "牋",
	"牘": "牍",
	"牐": "闸",
	"犛": "牦",
	"牴": "抵",
	"牽": "牵",
	"犧": "牺",
	"犢": "犊",
	"犖": "荦",
	"狀": "状",
	"獷": "犷",
	"獁": "犸",
	"猶": "犹",
	"狽": "狈",
	"麅": "狍",
	"獮": "狝",
	"獰": "狞",
	"獨": "独",
	"狹": "狭",
	"獅": "狮",
	"獪": "狯",
	"猙": "狰",
	"獄": "狱",
	"猻": "狲",
	"獫": "猃",
	"獵": "猎",
	"獼": "猕",
	"玀": "猡",
	"豬": "猪",
	"貓": "猫",
	"蝟": "猬",
	"獻": "献",
	"獃": "獃",
	"獺": "獭",
	"獲": "获",
	"玆": "兹",
	"璣": "玑",
	"璵": "玙",
	"瑒": "玚",
	"瑪": "玛",
	"玨": "珏",
	"瑋": "玮",
	"環": "环",
	"現": "现",
	"瑲": "玱",
	"璽": "玺",
	"瑉": "珉",
	"琺": "珐",
	"瓏": "珑",
	"珮": "珮",
	"璫": "珰",
	"琿": "珲",
	"琍": "璃",
	"璡": "琎",
	"璉": "琏",
	"瑣": "琐",
	"琯": "管",
	"瓊": "琼",
	"瑤": "瑶",
	"瑩": "莹",
	"瑯": "琅",
	"璦": "瑷",
	"璿": "璇",
	"瓔": "璎",
	"瓚": "瓒",
	"甕": "甕",
	"甌": "瓯",
	"甎": "砖",
	"甖": "罂",
	"産": "产",
	"甦": "苏",
	"甯": "宁",
	"電": "电",
	"畫": "画",
	"畱": "留",
	"疇": "畴",
	"癤": "疖",
	"療": "疗",
	"瘧": "疟",
	"癘": "疠",
	"瘍": "疡",
	"鬁": "疬",
	"瘡": "疮",
	"瘋": "疯",
	"皰": "疱",
	"癰": "痈",
	"痙": "痉",
	"癢": "痒",
	"瘂": "痖",
	"痠": "酸",
	"癆": "痨",
	"瘓": "痪",
	"癇": "痫",
	"癡": "癡",
	"痺": "痺",
	"癉": "瘅",
	"瘮": "瘆",
	"瘉": "愈",
	"瘞": "瘗",
	"瘺": "瘘",
	"癟": "瘪",
	"癱": "瘫",
	"瘻": "瘘",
	"癮": "瘾",
	"癭": "瘿",
	"癒": "愈",
	"癩": "癞",
	"癬": "癣",
	"癥": "症",
	"癧": "疬",
	"癲": "癫",
	"臒": "癯",
	"皚": "皑",
	"皺": "皱",
	"皸": "皲",
	"盃": "盃",
	"盞": "盏",
	"鹽": "盐",
	"監": "监",
	"蓋": "盖",
	"盜": "盗",
	"盤": "盘",
	"盪": "荡",
	"瞘": "眍",
	"眎": "视",
	"眡": "视",
	"眥": "眦",
	"矓": "眬",
	"著": "着",
	"睜": "睁",
	"睏": "困",
	"睞": "睐",
	"瞼": "睑",
	"瞞": "瞒",
	"矚": "瞩",
	"矇": "矇",
	"矯": "矫",
	"磯": "矶",
	"矽": "矽",
	"礬": "矾",
	"礦": "矿",
	"碭": "砀",
	"碼": "码",
	"磚": "砖",
	"硨": "砗",
	"硯": "砚",
	"碸": "砜",
	"砲": "炮",
	"礪": "砺",
	"礱": "砻",
	"礫": "砾",
	"礎": "础",
	"硜": "硁",
	"硃": "朱",
	"碩": "硕",
	"硤": "硖",
	"磽": "硗",
	"磑": "硙",
	"礄": "硚",
	"確": "确",
	"硶": "碜",
	"鹼": "硷",
	"礙": "碍",
	"磧": "碛",
	"磣": "碜",
	"镟": "碹",
	"磐": "磐",
	"礮": "炮",
	"禮": "礼",
	"禕": "祎",
	"祐": "祐",
	"祕": "祕",
	"禰": "祢",
	"禎": "祯",
	"禱": "祷",
	"禍": "祸",
	"祿": "禄",
	"稟": "禀",
	"禪": "禅",
	"離": "离",
	"禿": "秃",
	"稈": "秆",
	"秈": "籼",
	"種": "种",
	"積": "积",
	"稱": "称",
	"穢": "秽",
	"穠": "秾",
	"稅": "税",
	"穭": "稆",
	"稜": "棱",
	"穌": "稣",
	"稭": "秸",
	"穩": "稳",
	"穀": "谷",
	"穎": "颖",
	"穡": "穑",
	"穨": "颓",
	"穫": "获",
	"窮": "穷",
	"竊": "窃",
	"竅": "窍",
	"窯": "窑",
	"竄": "窜",
	"窩": "窝",
	"窺": "窥",
	"竇": "窦",
	"窶": "窭",
	"窰": "窑",
	"竈": "竈",
	"豎": "竖",
	"竝": "竝",
	"競": "竞",
	"竪": "竖",
	"篤": "笃",
	"筍": "笋",
	"筆": "笔",
	"筧": "笕",
	"箋": "笺",
	"籠": "笼",
	"籩": "笾",
	"築": "筑",
	"篳": "筚",
	"篩": "筛",
	"簹": "筜",
	"箏": "筝",
	"籌": "筹",
	"簽": "签",
	"簡": "简",
	"箇": "箇",
	"籙": "箓",
	"箠": "棰",
	"簀": "箦",
	"篋": "箧",
	"籜": "箨",
	"籮": "箩",
	"簞": "箪",
	"簫": "箫",
	"節": "节",
	"範": "范",
	"簣": "篑",
	"簍": "篓",
	"篛": "箬",
	"篠": "篠",
	"籃": "篮",
	"籬": "篱",
	"簑": "蓑",
	"籪": "簖",
	"籟": "籁",
	"籐": "藤",
	"籢": "奁",
	"籤": "签",
	"籥": "钥",
	"糴": "籴",
	"類": "类",
	"糶": "粜",
	"糲": "粝",
	"粵": "粤",
	"粧": "妆",
	"糞": "粪",
	"粬": "曲",
	"糧": "粮",
	"糝": "糁",
	"餱": "糇",
	"糢": "模",
	"糰": "团",
	"糸": "纟",
	"糾": "纠",
	"紀": "纪",
	"紂": "纣",
	"約": "约",
	"紅": "红",
	"紆": "纡",
	"紇": "纥",
	"紈": "纨",
	"紉": "纫",
	"紋": "纹",
	"納": "纳",
	"紐": "纽",
	"紓": "纾",
	"純": "纯",
	"紕": "纰",
	"紖": "纼",
	"紗": "纱",
	"紘": "纮",
	"紙": "纸",
	"級": "级",
	"紛": "纷",
	"紜": "纭",
	"紝": "纴",
	"紡": "纺",
	"紥": "扎",
	"緊": "紧",
	"細": "细",
	"紱": "绂",
	"紲": "绁",
	"紳": "绅",
	"紵": "纻",
	"紹": "绍",
	"紺": "绀",
	"紼": "绋",
	"紿": "绐",
	"絀": "绌",
	"終": "终",
	"絃": "弦",
	"組": "组",
	"絆": "绊",
	"絍": "纴",
	"絎": "绗",
	"絏": "绁",
	"結": "结",
	"絕": "绝",
	"絛": "绦",
	"絝": "绔",
	"絞": "绞",
	"絡": "络",
	"絢": "绚",
	"給": "给",
	"絨": "绒",
	"絰": "绖",
	"統": "统",
	"絳": "绛",
	"縶": "絷",
	"絹": "绢",
	"綁": "绑",
	"綃": "绡",
	"綆": "绠",
	"綈": "绨",
	"綉": "绣",
	"綌": "绤",
	"綏": "绥",
	"綑": "捆",
	"經": "经",
	"綜": "综",
	"綞": "缍",
	"綠": "绿",
	"綢": "绸",
	"綣": "绻",
	"綫": "线",
	"綬": "绶",
	"維": "维",
	"綯": "绹",
	"綰": "绾",
	"綱": "纲",
	"網": "网",
	"綳": "绷",
	"綴": "缀",
	"綵": "䌽",
	"綸": "纶",
	"綹": "绺",
	"綺": "绮",
	"綻": "绽",
	"綽": "绰",
	"綾": "绫",
	"綿": "绵",
	"緄": "绲",
	"緇": "缁",
	"緋": "绯",
	"緍": "缗",
	"緒": "绪",
	"緓": "绬",
	"緔": "绱",
	"緗": "缃",
	"緘": "缄",
	"緙": "缂",
	"線": "缐",
	"緜": "绵",
	"緝": "缉",
	"緞": "缎",
	"締": "缔",
	"緡": "缗",
	"緣": "缘",
	"緤": "绁",
	"緦": "缌",
	"編": "编",
	"緩": "缓",
	"緬": "缅",
	"緯": "纬",
	"緱": "缑",
	"緲": "缈",
	"練": "练",
	"緶": "缏",
	"緹": "缇",
	"緻": "致",
	"緼": "缊",
	"縂": "总",
	"縈": "萦",
	"縉": "缙",
	"縊": "缢",
	"縋": "缒",
	"縐": "绉",
	"縑": "缣",
	"縕": "缊",
	"縗": "缞",
	"縚": "绦",
	"縛": "缚",
	"縝": "缜",
	"縞": "缟",
	"縟": "缛",
	"縧": "绦",
	"縫": "缝",
	"縭": "缡",
	"縮": "缩",
	"縯": "演",
	"縱": "纵",
	"縲": "缧",
	"縴": "纤",
	"縵": "缦",
	"縷": "缕",
	"縹": "缥",
	"績": "绩",
	"繃": "绷",
	"繅": "缫",
	"繆": "缪",
	"繈": "襁",
	"繒": "缯",
	"織": "织",
	"繕": "缮",
	"繖": "伞",
	"繙": "翻",
	"繚": "缭",
	"繞": "绕",
	"繡": "绣",
	"繢": "缋",
	"繦": "襁",
	"繩": "绳",
	"繪": "绘",
	"繫": "系",
	"繭": "茧",
	"繮": "缰",
	"繯": "缳",
	"繰": "缲",
	"繳": "缴",
	"繹": "绎",
	"繼": "继",
	"繽": "缤",
	"繾": "缱",
	"纇": "颣",
	"纈": "缬",
	"纊": "纩",
	"續": "续",
	"纍": "累",
	"纏": "缠",
	"纓": "缨",
	"纖": "纤",
	"纘": "缵",
	"纜": "缆",
	"韁": "缰",
	"缽": "钵",
	"罌": "罂",
	"罈": "坛",
	"罋": "罋",
	"罎": "坛",
	"罏": "垆",
	"羅": "罗",
	"罰": "罚",
	"罷": "罢",
	"羆": "罴",
	"罵": "骂",
	"罸": "罚",
	"羈": "羁",
	"羋": "芈",
	"羥": "羟",
	"羨": "羡",
	"羢": "绒",
	"羶": "膻",
	"翹": "翘",
	"翽": "翙",
	"翬": "翚",
	"翺": "翱",
	"耑": "端",
	"耡": "锄",
	"耮": "耢",
	"耬": "耧",
	"聳": "耸",
	"聶": "聂",
	"聾": "聋",
	"職": "职",
	"聹": "聍",
	"聯": "联",
	"聞": "闻",
	"聵": "聩",
	"聰": "聪",
	"聼": "听",
	"肅": "肃",
	"腸": "肠",
	"膚": "肤",
	"膁": "肷",
	"腎": "肾",
	"腫": "肿",
	"脹": "胀",
	"脅": "胁",
	"膽": "胆",
	"腖": "胨",
	"臚": "胪",
	"脛": "胫",
	"膠": "胶",
	"脇": "胁",
	"脈": "脉",
	"膾": "脍",
	"髒": "脏",
	"臍": "脐",
	"腦": "脑",
	"膿": "脓",
	"臠": "脔",
	"腳": "脚",
	"脣": "脣",
	"脩": "脩",
	"脫": "脱",
	"腡": "脶",
	"臉": "脸",
	"臘": "腊",
	"醃": "腌",
	"膕": "腘",
	"齶": "腭",
	"膩": "腻",
	"靦": "腼",
	"膃": "腽",
	"騰": "腾",
	"臏": "膑",
	"臢": "臜",
	"臟": "脏",
	"臯": "皋",
	"臺": "台",
	"輿": "舆",
	"舖": "铺",
	"舘": "馆",
	"艤": "舣",
	"艦": "舰",
	"艙": "舱",
	"艫": "舻",
	"艢": "樯",
	"艣": "橹",
	"艪": "橹",
	"艱": "艰",
	"豔": "艳",
	"艷": "艳",
	"艸": "艸",
	"藝": "艺",
	"薌": "芗",
	"蕪": "芜",
	"蘆": "芦",
	"蓯": "苁",
	"葦": "苇",
	"藶": "苈",
	"莧": "苋",
	"萇": "苌",
	"蒼": "苍",
	"苧": "苎",
	"蘇": "苏",
	"蘋": "苹",
	"莖": "茎",
	"蘢": "茏",
	"蔦": "茑",
	"荊": "荆",
	"薦": "荐",
	"薘": "荙",
	"莢": "荚",
	"蕘": "荛",
	"蓽": "荜",
	"蕎": "荞",
	"薈": "荟",
	"薺": "荠",
	"蕩": "荡",
	"葷": "荤",
	"蕁": "荨",
	"藎": "荩",
	"蓀": "荪",
	"蔭": "荫",
	"蕒": "荬",
	"葒": "荭",
	"葤": "荮",
	"藥": "药",
	"蒞": "莅",
	"蓧": "莜",
	"萊": "莱",
	"蓮": "莲",
	"蒔": "莳",
	"萵": "莴",
	"薟": "莶",
	"蕕": "莸",
	"鶯": "莺",
	"蓴": "莼",
	"菴": "庵",
	"菸": "菸",
	"蘀": "萚",
	"蘿": "萝",
	"螢": "萤",
	"蕭": "萧",
	"薩": "萨",
	"葠": "参",
	"葯": "药",
	"蔥": "葱",
	"蕆": "蒇",
	"蕢": "蒉",
	"蔣": "蒋",
	"蔞": "蒌",
	"蒐": "搜",
	"蒓": "莼",
	"蓆": "席",
	"藍": "蓝",
	"薊": "蓟",
	"蘺": "蓠",
	"蓡": "参",
	"蕷": "蓣",
	"鎣": "蓥",
	"驀": "蓦",
	"蔆": "菱",
	"蔴": "麻",
	"薔": "蔷",
	"蘞": "蔹",
	"藺": "蔺",
	"藹": "蔼",
	"蕓": "芸",
	"蘄": "蕲",
	"蘊": "蕴",
	"藪": "薮",
	"薰": "薰",
	"蘚": "藓",
	"虜": "虏",
	"虛": "虚",
	"蟲": "虫",
	"虯": "虬",
	"蟣": "虮",
	"雖": "虽",
	"蝦": "虾",
	"蠆": "虿",
	"蝕": "蚀",
	"蟻": "蚁",
	"螞": "蚂",
	"蠶": "蚕",
	"蠔": "蚝",
	"蜆": "蚬",
	"蠱": "蛊",
	"蠣": "蛎",
	"蟶": "蛏",
	"蠻": "蛮",
	"蟄": "蛰",
	"蛺": "蛱",
	"蟯": "蛲",
	"螄": "蛳",
	"蠐": "蛴",
	"蛻": "蜕",
	"蝸": "蜗",
	"蠟": "蜡",
	"蠅": "蝇",
	"蟈": "蝈",
	"蟬": "蝉",
	"蠍": "蝎",
	"蝨": "虱",
	"螻": "蝼",
	"蠑": "蝾",
	"螿": "螀",
	"螘": "蚁",
	"蟎": "螨",
	"蠨": "蟏",
	"釁": "衅",
	"衆": "众",
	"衊": "衊",
	"銜": "衔",
	"衚": "胡",
	"衝": "冲",
	"衞": "卫",
	"補": "补",
	"襯": "衬",
	"袞": "衮",
	"衹": "只",
	"襖": "袄",
	"褘": "袆",
	"襪": "袜",
	"襲": "袭",
	"襏": "袯",
	"裝": "装",
	"襠": "裆",
	"褌": "裈",
	"裊": "袅",
	"裌": "夹",
	"裏": "里",
	"裡": "里",
	"褳": "裢",
	"襝": "裣",
	"褲": "裤",
	"襇": "裥",
	"製": "制",
	"褸": "褛",
	"襤": "褴",
	"襍": "杂",
	"襴": "襕",
	"覈": "覈",
	"見": "见",
	"覎": "觃",
	"規": "规",
	"覓": "觅",
	"覔": "觅",
	"視": "视",
	"覘": "觇",
	"覜": "眺",
	"覡": "觋",
	"覥": "觍",
	"覦": "觎",
	"覬": "觊",
	"覯": "觏",
	"覰": "觑",
	"覲": "觐",
	"覷": "觑",
	"覺": "觉",
	"覻": "觑",
	"覽": "览",
	"覿": "觌",
	"觀": "观",
	"觝": "抵",
	"觴": "觞",
	"觸": "触",
	"觶": "觯",
	"訁": "讠",
	"訂": "订",
	"訃": "讣",
	"計": "计",
	"訊": "讯",
	"訌": "讧",
	"討": "讨",
	"訏": "吁",
	"訐": "讦",
	"訒": "讱",
	"訓": "训",
	"訕": "讪",
	"訖": "讫",
	"託": "讬",
	"記": "记",
	"訛": "讹",
	"訝": "讶",
	"訟": "讼",
	"訢": "䜣",
	"訣": "诀",
	"訥": "讷",
	"訦": "谌",
	"訩": "讻",
	"訪": "访",
	"設": "设",
	"許": "许",
	"訴": "诉",
	"訶": "诃",
	"診": "诊",
	"註": "注",
	"証": "証",
	"詁": "诂",
	"詆": "诋",
	"詎": "讵",
	"詐": "诈",
	"詒": "诒",
	"詔": "诏",
	"評": "评",
	"詖": "诐",
	"詗": "诇",
	"詘": "诎",
	"詛": "诅",
	"詞": "词",
	"讋": "詟",
	"詡": "诩",
	"詢": "询",
	"詣": "诣",
	"試": "试",
	"詩": "诗",
	"詫": "诧",
	"詬": "诟",
	"詭": "诡",
	"詮": "诠",
	"詰": "诘",
	"話": "话",
	"該": "该",
	"詳": "详",
	"詵": "诜",
	"詼": "诙",
	"詾": "讻",
	"詿": "诖",
	"誄": "诔",
	"誅": "诛",
	"誆": "诓",
	"譽": "誉",
	"謄": "誊",
	"誌": "志",
	"認": "认",
	"誑": "诳",
	"誒": "诶",
	"誕": "诞",
	"誘": "诱",
	"誚": "诮",
	"語": "语",
	"誠": "诚",
	"誡": "诫",
	"誣": "诬",
	"誤": "误",
	"誥": "诰",
	"誦": "诵",
	"誨": "诲",
	"說": "说",
	"説": "说",
	"誰": "谁",
	"課": "课",
	"誶": "谇",
	"誹": "诽",
	"誼": "谊",
	"調": "调",
	"諂": "谄",
	"諄": "谆",
	"談": "谈",
	"諉": "诿",
	"請": "请",
	"諍": "诤",
	"諏": "诹",
	"諑": "诼",
	"諒": "谅",
	"論": "论",
	"諗": "谂",
	"諛": "谀",
	"諜": "谍",
	"諝": "谞",
	"諞": "谝",
	"諡": "谥",
	"諢": "诨",
	"諤": "谔",
	"諦": "谛",
	"諧": "谐",
	"諫": "谏",
	"諭": "谕",
	"諱": "讳",
	"諳": "谙",
	"諶": "谌",
	"諷": "讽",
	"諸": "诸",
	"諺": "谚",
	"諼": "谖",
	"諾": "诺",
	"謀": "谋",
	"謁": "谒",
	"謂": "谓",
	"謅": "诌",
	"謊": "谎",
	"謎": "谜",
	"謐": "谧",
	"謖": "谡",
	"謗": "谤",
	"謙": "谦",
	"謚": "谥",
	"講": "讲",
	"謝": "谢",
	"謠": "谣",
	"謨": "谟",
	"謫": "谪",
	"謬": "谬",
	"謳": "讴",
	"謹": "谨",
	"謾": "谩",
	"譁": "譁",
	"譆": "嘻",
	"證": "证",
	"譌": "讹",
	"譎": "谲",
	"譏": "讥",
	"譖": "谮",
	"識": "识",
	"譙": "谯",
	"譚": "谭",
	"譜": "谱",
	"譟": "譟",
	"譫": "谵",
	"譭": "毁",
	"譯": "译",
	"議": "议",
	"譴": "谴",
	"譸": "诪",
	"譾": "谫",
	"讀": "读",
	"讁": "谪",
	"讅": "审",
	"讌": "燕",
	"讎": "雠",
	"讐": "雠",
	"讒": "谗",
	"讓": "让",
	"讕": "谰",
	"讖": "谶",
	"讚": "讚",
	"讛": "呓",
	"讜": "谠",
	"讞": "谳",
	"谿": "谿",
	"豶": "豮",
	"貍": "狸",
	"貝": "贝",
	"貞": "贞",
	"貟": "贠",
	"負": "负",
	"財": "财",
	"貢": "贡",
	"貧": "贫",
	"貨": "货",
	"販": "贩",
	"貪": "贪",
	"貫": "贯",
	"責": "责",
	"貯": "贮",
	"貰": "贳",
	"貲": "赀",
	"貳": "贰",
	"貴": "贵",
	"貶": "贬",
	"貸": "贷",
	"貺": "贶",
	"費": "费",
	"貼": "贴",
	"貽": "贻",
	"貿": "贸",
	"賀": "贺",
	"賁": "贲",
	"賂": "赂",
	"賃": "赁",
	"賄": "贿",
	"賅": "赅",
	"資": "资",
	"賈": "贾",
	"賉": "恤",
	"賊": "贼",
	"賍": "赃",
	"賑": "赈",
	"賒": "赊",
	"賔": "宾",
	"賕": "赇",
	"賙": "赒",
	"賚": "赉",
	"賛": "赞",
	"賜": "赐",
	"賞": "赏",
	"賠": "赔",
	"賡": "赓",
	"賢": "贤",
	"賤": "贱",
	"賦": "赋",
	"賧": "赕",
	"質": "质",
	"賫": "赍",
	"賬": "账",
	"賭": "赌",
	"賮": "赆",
	"賴": "赖",
	"賵": "赗",
	"賸": "剩",
	"賺": "赚",
	"賻": "赙",
	"購": "购",
	"賽": "赛",
	"賾": "赜",
	"贄": "贽",
	"贅": "赘",
	"贇": "赟",
	"贈": "赠",
	"贊": "赞",
	"贋": "赝",
	"贍": "赡",
	"贏": "赢",
	"贐": "赆",
	"贓": "赃",
	"贔": "赑",
	"贖": "赎",
	"贗": "赝",
	"贛": "赣",
	"贜": "赃",
	"齎": "赍",
	"赬": "赪",
	"趙": "赵",
	"趕": "赶",
	"趨": "趋",
	"趲": "趱",
	"躉": "趸",
	"躍": "跃",
	"蹌": "跄",
	"蹠": "蹠",
	"躒": "跞",
	"跡": "迹",
	"踐": "践",
	"躂": "跶",
	"蹺": "跷",
	"蹕": "跸",
	"躚": "跹",
	"躋": "跻",
	"跼": "局",
	"踴": "踊",
	"躊": "踌",
	"踡": "蜷",
	"蹤": "踪",
	"躓": "踬",
	"躑": "踯",
	"躡": "蹑",
	"蹣": "蹒",
	"蹟": "迹",
	"躕": "蹰",
	"躥": "蹿",
	"躪": "躏",
	"躦": "躜",
	"軀": "躯",
	"躰": "体",
	"軃": "亸",
	"車": "车",
	"軋": "轧",
	"軌": "轨",
	"軑": "轪",
	"軒": "轩",
	"軔": "轫",
	"軛": "轭",
	"軟": "软",
	"軤": "轷",
	"軫": "轸",
	"軲": "轱",
	"軸": "轴",
	"軹": "轵",
	"軺": "轺",
	"軻": "轲",
	"軼": "轶",
	"軾": "轼",
	"較": "较",
	"輅": "辂",
	"輇": "辁",
	"輈": "辀",
	"載": "载",
	"輊": "轾",
	"輒": "辄",
	"輓": "挽",
	"輔": "辅",
	"輕": "轻",
	"輛": "辆",
	"輜": "辎",
	"輝": "辉",
	"輞": "辋",
	"輟": "辍",
	"輥": "辊",
	"輦": "辇",
	"輩": "辈",
	"輪": "轮",
	"輬": "辌",
	"輭": "软",
	"輯": "辑",
	"輳": "辏",
	"輸": "输",
	"輻": "辐",
	"輼": "辒",
	"輾": "辗",
	"轀": "辒",
	"轄": "辖",
	"轅": "辕",
	"轆": "辘",
	"轉": "转",
	"轍": "辙",
	"轎": "轿",
	"轔": "辚",
	"轟": "轰",
	"轡": "辔",
	"轢": "轹",
	"轤": "轳",
	"辭": "辞",
	"辤": "辞",
	"辯": "辩",
	"辮": "辫",
	"辳": "农",
	"邊": "边",
	"遼": "辽",
	"達": "达",
	"遷": "迁",
	"迆": "迤",
	"過": "过",
	"邁": "迈",
	"運": "运",
	"還": "还",
	"這": "这",
	"進": "进",
	"遠": "远",
	"違": "违",
	"連": "连",
	"遲": "迟",
	"邇": "迩",
	"逕": "迳",
	"迴": "回",
	"迺": "乃",
	"適": "适",
	"選": "选",
	"遜": "逊",
	"遞": "递",
	"邐": "逦",
	"週": "週",
	"邏": "逻",
	"遺": "遗",
	"遙": "遥",
	"鄧": "邓",
	"鄺": "邝",
	"鄔": "邬",
	"郵": "邮",
	"鄒": "邹",
	"鄴": "邺",
	"鄰": "邻",
	"鬱": "郁",
	"郃": "合",
	"郤": "郄",
	"郟": "郏",
	"鄶": "郐",
	"鄭": "郑",
	"鄆": "郓",
	"酈": "郦",
	"鄖": "郧",
	"鄲": "郸",
	"鄕": "乡",
	"鄘": "墉",
	"醞": "酝",
	"醱": "酦",
	"酧": "酬",
	"醯": "酰",
	"醬": "酱",
	"釅": "酽",
	"釃": "酾",
	"釀": "酿",
	"醖": "酝",
	"醻": "酬",
	"醼": "燕",
	"釋": "释",
	"釐": "厘",
	"釓": "钆",
	"釔": "钇",
	"釕": "钌",
	"釗": "钊",
	"釘": "钉",
	"釙": "钋",
	"針": "针",
	"釣": "钓",
	"釤": "钐",
	"釦": "扣",
	"釧": "钏",
	"釩": "钒",
	"釬": "焊",
	"釵": "钗",
	"釷": "钍",
	"釹": "钕",
	"釺": "钎",
	"鈀": "钯",
	"鈁": "钫",
	"鈃": "钘",
	"鈄": "钭",
	"鈅": "钥",
	"鈈": "钚",
	"鈉": "钠",
	"鈍": "钝",
	"鈎": "钩",
	"鈐": "钤",
	"鈑": "钣",
	"鈒": "钑",
	"鈔": "钞",
	"鈕": "钮",
	"鈞": "钧",
	"鈡": "钟",
	"鈣": "钙",
	"鈥": "钬",
	"鈦": "钛",
	"鈧": "钪",
	"鈮": "铌",
	"鈰": "铈",
	"鈳": "钶",
	"鈴": "铃",
	"鈷": "钴",
	"鈸": "钹",
	"鈹": "铍",
	"鈺": "钰",
	"鈽": "钸",
	"鈾": "铀",
	"鈿": "钿",
	"鉀": "钾",
	"鉄": "铁",
	"鉆": "钻",
	"鉈": "铊",
	"鉉": "铉",
	"鉋": "铇",
	"鉍": "铋",
	"鉑": "铂",
	"鉕": "钷",
	"鉗": "钳",
	"鉚": "铆",
	"鉛": "铅",
	"鉞": "钺",
	"鉢": "钵",
	"鉤": "钩",
	"鉦": "钲",
	"鉬": "钼",
	"鉭": "钽",
	"鉲": "锎",
	"鑒": "鉴",
	"鉶": "铏",
	"鉸": "铰",
	"鉺": "铒",
	"鉻": "铬",
	"鉿": "铪",
	"銀": "银",
	"銃": "铳",
	"銅": "铜",
	"銍": "铚",
	"銑": "铣",
	"銓": "铨",
	"銕": "铁",
	"銖": "铢",
	"銘": "铭",
	"銚": "铫",
	"銛": "铦",
	"銠": "铑",
	"銣": "铷",
	"銥": "铱",
	"銦": "铟",
	"銨": "铵",
	"銩": "铥",
	"銪": "铕",
	"銫": "铯",
	"銬": "铐",
	"鑾": "銮",
	"銱": "铞",
	"銲": "焊",
	"銳": "锐",
	"銷": "销",
	"銹": "锈",
	"銻": "锑",
	"銼": "锉",
	"鋁": "铝",
	"鋂": "镅",
	"鋃": "锒",
	"鋅": "锌",
	"鋇": "钡",
	"鋌": "铤",
	"鋏": "铗",
	"鋒": "锋",
	"鋙": "铻",
	"鋜": "镯",
	"鋝": "锊",
	"鋟": "锓",
	"鋣": "铘",
	"鋤": "锄",
	"鋥": "锃",
	"鋦": "锔",
	"鋨": "锇",
	"鋩": "铓",
	"鋪": "铺",
	"鋮": "铖",
	"鋯": "锆",
	"鋰": "锂",
	"鋱": "铽",
	"鋶": "锍",
	"鋸": "锯",
	"鋻": "鉴",
	"鋼": "钢",
	"錁": "锞",
	"錆": "锖",
	"錇": "锫",
	"錈": "锩",
	"錏": "铔",
	"錐": "锥",
	"錒": "锕",
	"錕": "锟",
	"錘": "锤",
	"錙": "锱",
	"錚": "铮",
	"錛": "锛",
	"錟": "锬",
	"錠": "锭",
	"錡": "锜",
	"錢": "钱",
	"錦": "锦",
	"錨": "锚",
	"錩": "锠",
	"錫": "锡",
	"錮": "锢",
	"錯": "错",
	"錳": "锰",
	"錶": "表",
	"錸": "铼",
	"錼": "镎",
	"鏨": "錾",
	"鍀": "锝",
	"鍁": "锨",
	"鍃": "锪",
	"鍆": "钔",
	"鍇": "锴",
	"鍈": "锳",
	"鍊": "炼",
	"鍋": "锅",
	"鍍": "镀",
	"鍔": "锷",
	"鍘": "铡",
	"鍚": "钖",
	"鍛": "锻",
	"鍠": "锽",
	"鍤": "锸",
	"鍥": "锲",
	"鍩": "锘",
	"鍫": "锹",
	"鍬": "锹",
	"鍰": "锾",
	"鍵": "键",
	"鍶": "锶",
	"鍺": "锗",
	"鍼": "针",
	"鍾": "锺",
	"鎂": "镁",
	"鎄": "锿",
	"鎇": "镅",
	"鎊": "镑",
	"鎋": "辖",
	"鎔": "镕",
	"鎖": "锁",
	"鎘": "镉",
	"鎚": "锤",
	"鎛": "镈",
	"鎡": "镃",
	"鎢": "钨",
	"鎦": "镏",
	"鎧": "铠",
	"鎩": "铩",
	"鎪": "锼",
	"鎬": "镐",
	"鎮": "镇",
	"鎰": "镒",
	"鎲": "镋",
	"鎳": "镍",
	"鎵": "镓",
	"鎸": "镌",
	"鎿": "镎",
	"鏃": "镞",
	"鏇": "镟",
	"鏈": "链",
	"鏌": "镆",
	"鏍": "镙",
	"鏐": "镠",
	"鏑": "镝",
	"鏗": "铿",
	"鏘": "锵",
	"鏚": "戚",
	"鏜": "镗",
	"鏝": "镘",
	"鏞": "镛",
	"鏡": "镜",
	"鏢": "镖",
	"鏤": "镂",
	"鏰": "镚",
	"鏵": "铧",
	"鏷": "镤",
	"鏹": "镪",
	"鏽": "锈",
	"鐃": "铙",
	"鐋": "铴",
	"鐐": "镣",
	"鐒": "铹",
	"鐓": "镦",
	"鐔": "镡",
	"鐘": "钟",
	"鐙": "镫",
	"鐝": "镢",
	"鐠": "镨",
	"鐦": "锎",
	"鐧": "锏",
	"鐨": "镄",
	"鐫": "镌",
	"鐮": "镰",
	"鐲": "镯",
	"鐳": "镭",
	"鐵": "铁",
	"鐶": "镮",
	"鐸": "铎",
	"鐺": "铛",
	"鐿": "镱",
	"鑄": "铸",
	"鑊": "镬",
	"鑌": "镔",
	"鑑": "鉴",
	"鑔": "镲",
	"鑕": "锧",
	"鑛": "矿",
	"鑞": "镴",
	"鑠": "铄",
	"鑣": "镳",
	"鑤": "刨",
	"鑥": "镥",
	"鑪": "炉",
	"鑭": "镧",
	"鑰": "钥",
	"鑱": "镵",
	"鑲": "镶",
	"鑷": "镊",
	"鑹": "镩",
	"鑼": "锣",
	"鑽": "钻",
	"钁": "镢",
	"钂": "镋",
	"長": "长",
	"門": "门",
	"閂": "闩",
	"閃": "闪",
	"閆": "闫",
	"閈": "闬",
	"閉": "闭",
	"閌": "闶",
	"閎": "闳",
	"閏": "闰",
	"閑": "闲",
	"閒": "闲",
	"間": "间",
	"閔": "闵",
	"閘": "闸",
	"閙": "闹",
	"閡": "阂",
	"関": "关",
	"閣": "阁",
	"閤": "合",
	"閥": "阀",
	"閨": "闺",
	"閩": "闽",
	"閫": "阃",
	"閬": "阆",
	"閭": "闾",
	"閱": "阅",
	"閲": "阅",
	"閶": "阊",
	"閹": "阉",
	"閻": "阎",
	"閼": "阏",
	"閽": "阍",
	"閾": "阈",
	"閿": "阌",
	"闃": "阒",
	"闆": "板",
	"闈": "闱",
	"闊": "阔",
	"闋": "阕",
	"闌": "阑",
	"闍": "阇",
	"闐": "阗",
	"闒": "阘",
	"闓": "闿",
	"闔": "阖",
	"闕": "阙",
	"闖": "闯",
	"闚": "窥",
	"闞": "阚",
	"闠": "阓",
	"闡": "阐",
	"闢": "闢",
	"闤": "阛",
	"闥": "闼",
	"鬧": "闹",
	"鬮": "阄",
	"鬩": "阋",
	"隊": "队",
	"阬": "坑",
	"阯": "址",
	"陽": "阳",
	"陰": "阴",
	"陣": "阵",
	"階": "阶",
	"際": "际",
	"陸": "陆",
	"隴": "陇",
	"陳": "陈",
	"陘": "陉",
	"陝": "陕",
	"陞": "陞",
	"隉": "陧",
	"隕": "陨",
	"險": "险",
	"隂": "阴",
	"隄": "堤",
	"隨": "随",
	"隱": "隐",
	"隖": "坞",
	"隣": "邻",
	"隸": "隶",
	"隷": "隶",
	"隻": "只",
	"雋": "隽",
	"難": "难",
	"雛": "雏",
	"雞": "鸡",
	"靂": "雳",
	"霧": "雾",
	"霽": "霁",
	"黴": "黴",
	"霑": "沾",
	"霛": "灵",
	"霤": "溜",
	"靄": "霭",
	"靚": "靓",
	"靜": "静",
	"靨": "靥",
	"靭": "韧",
	"鞀": "鼗",
	"鞉": "鼗",
	"韃": "鞑",
	"鞽": "鞒",
	"鞦": "鞦",
	"韉": "鞯",
	"韝": "鞴",
	"韆": "千",
	"韋": "韦",
	"韌": "韧",
	"韍": "韨",
	"韓": "韩",
	"韙": "韪",
	"韜": "韬",
	"韞": "韫",
	"韤": "袜",
	"韻": "韵",
	"頁": "页",
	"頂": "顶",
	"頃": "顷",
	"項": "项",
	"順": "顺",
	"頇": "顸",
	"須": "须",
	"頊": "顼",
	"頌": "颂",
	"頎": "颀",
	"頏": "颃",
	"預": "预",
	"頑": "顽",
	"頒": "颁",
	"頓": "顿",
	"頗": "颇",
	"領": "领",
	"頜": "颌",
	"頡": "颉",
	"頤": "颐",
	"頦": "颏",
	"頫": "俯",
	"頮": "颒",
	"頰": "颊",
	"頲": "颋",
	"頴": "颕",
	"頷": "颔",
	"頸": "颈",
	"頹": "颓",
	"頻": "频",
	"頽": "颓",
	"顆": "颗",
	"題": "题",
	"額": "额",
	"顎": "颚",
	"顏": "颜",
	"顒": "颙",
	"顓": "颛",
	"顔": "颜",
	"顙": "颡",
	"顛": "颠",
	"顢": "颟",
	"顥": "颢",
	"顧": "顾",
	"顫": "颤",
	"顬": "颥",
	"顰": "颦",
	"顱": "颅",
	"顳": "颞",
	"顴": "颧",
	"風": "风",
	"颭": "飐",
	"颮": "飑",
	"颯": "飒",
	"颱": "台",
	"颳": "刮",
	"颶": "飓",
	"颸": "飔",
	"颺": "飏",
	"颻": "飖",
	"颼": "飕",
	"飀": "飗",
	"飃": "飘",
	"飄": "飘",
	"飆": "飙",
	"飇": "飙",
	"飈": "飚",
	"飛": "飞",
	"飢": "饥",
	"飣": "饤",
	"飥": "饦",
	"饗": "飨",
	"飩": "饨",
	"飪": "饪",
	"飫": "饫",
	"飭": "饬",
	"飯": "饭",
	"飲": "饮",
	"飴": "饴",
	"飼": "饲",
	"飽": "饱",
	"飾": "饰",
	"飿": "饳",
	"餃": "饺",
	"餄": "饸",
	"餅": "饼",
	"餉": "饷",
	"餌": "饵",
	"饜": "餍",
	"餎": "饹",
	"餏": "饻",
	"餑": "饽",
	"餒": "馁",
	"餓": "饿",
	"餕": "馂",
	"餖": "饾",
	"餚": "肴",
	"餛": "馄",
	"餜": "馃",
	"餞": "饯",
	"餡": "馅",
	"館": "馆",
	"餳": "饧",
	"餵": "𫗭",
	"餶": "馉",
	"餷": "馇",
	"餺": "馎",
	"餼": "饩",
	"餽": "馈",
	"餾": "馏",
	"餿": "馊",
	"饁": "馌",
	"饃": "馍",
	"饅": "馒",
	"饈": "馐",
	"饉": "馑",
	"饊": "馓",
	"饋": "馈",
	"饌": "馔",
	"饑": "饥",
	"饒": "饶",
	"饝": "馍",
	"饞": "馋",
	"饢": "馕",
	"馬": "马",
	"馭": "驭",
	"馱": "驮",
	"馳": "驰",
	"馴": "驯",
	"馹": "驲",
	"駁": "驳",
	"駐": "驻",
	"駑": "驽",
	"駒": "驹",
	"駔": "驵",
	"駕": "驾",
	"駘": "骀",
	"駙": "驸",
	"駛": "驶",
	"駝": "驼",
	"駟": "驷",
	"駡": "骂",
	"駢": "骈",
	"駭": "骇",
	"駮": "驳",
	"駰": "骃",
	"駱": "骆",
	"駸": "骎",
	"駿": "骏",
	"騁": "骋",
	"騂": "骍",
	"騅": "骓",
	"騌": "骔",
	"騍": "骒",
	"騎": "骑",
	"騏": "骐",
	"騐": "验",
	"騖": "骛",
	"騗": "骗",
	"騙": "骗",
	"騣": "鬃",
	"騤": "骙",
	"騫": "骞",
	"騭": "骘",
	"騮": "骝",
	"騶": "驺",
	"騷": "骚",
	"騸": "骟",
	"騾": "骡",
	"驁": "骜",
	"驂": "骖",
	"驃": "骠",
	"驄": "骢",
	"驅": "驱",
	"驊": "骅",
	"驌": "骕",
	"驍": "骁",
	"驏": "骣",
	"驕": "骄",
	"驗": "验",
	"驘": "骡",
	"驛": "驿",
	"驟": "骤",
	"驢": "驴",
	"驤": "骧",
	"驥": "骥",
	"驦": "骦",
	"驪": "骊",
	"驫": "骉",
	"骾": "鲠",
	"髏": "髅",
	"髖": "髋",
	"髕": "髌",
	"髩": "鬓",
	"髮": "发",
	"鬆": "松",
	"鬍": "胡",
	"鬢": "鬓",
	"鬚": "须",
	"鬦": "斗",
	"鬨": "鬨",
	"鬭": "斗",
	"魘": "魇",
	"魎": "魉",
	"魚": "鱼",
	"魛": "鱽",
	"魢": "鱾",
	"魨": "鲀",
	"魯": "鲁",
	"魴": "鲂",
	"魷": "鱿",
	"魺": "鲄",
	"鮁": "鲅",
	"鮃": "鲆",
	"鮊": "鲌",
	"鮋": "鲉",
	"鮌": "鲧",
	"鮍": "鲏",
	"鮎": "鲇",
	"鮐": "鲐",
	"鮑": "鲍",
	"鮒": "鲋",
	"鮓": "鲊",
	"鮚": "鲒",
	"鮜": "鲘",
	"鮞": "鲕",
	"鮦": "鲖",
	"鮪": "鲔",
	"鮫": "鲛",
	"鮭": "鲑",
	"鮮": "鲜",
	"鮳": "鲓",
	"鮶": "鲪",
	"鮷": "鳀",
	"鮺": "鲝",
	"鯀": "鲧",
	"鯁": "鲠",
	"鯇": "鲩",
	"鯉": "鲤",
	"鯊": "鲨",
	"鯒": "鲬",
	"鯔": "鲻",
	"鯕": "鲯",
	"鯖": "鲭",
	"鯗": "鲞",
	"鯛": "鲷",
	"鯝": "鲴",
	"鯡": "鲱",
	"鯢": "鲵",
	"鯤": "鲲",
	"鯧": "鲳",
	"鯨": "鲸",
	"鯪": "鲮",
	"鯫": "鲰",
	"鯰": "鲶",
	"鯴": "鲺",
	"鯵": "鲹",
	"鯷": "鳀",
	"鯽": "鲫",
	"鯿": "鳊",
	"鰁": "鳈",
	"鰂": "鲗",
	"鰃": "鳂",
	"鰈": "鲽",
	"鰉": "鳇",
	"鰌": "鳅",
	"鰍": "鳅",
	"鰏": "鲾",
	"鰐": "鳄",
	"鰒": "鳆",
	"鰓": "鳃",
	"鰛": "鳁",
	"鰜": "鳒",
	"鰟": "鳑",
	"鰠": "鳋",
	"鰣": "鲥",
	"鰥": "鳏",
	"鰨": "鳎",
	"鰩": "鳐",
	"鰭": "鳍",
	"鰮": "鳁",
	"鰱": "鲢",
	"鰲": "鳌",
	"鰳": "鳓",
	"鰵": "鳘",
	"鰷": "鲦",
	"鰹": "鲣",
	"鰺": "鲹",
	"鰻": "鳗",
	"鰼": "鳛",
	"鰾": "鳔",
	"鱂": "鳉",
	"鱅": "鳙",
	"鱈": "鳕",
	"鱉": "鳖",
	"鱒": "鳟",
	"鱓": "鳝",
	"鱔": "鳝",
	"鱖": "鳜",
	"鱗": "鳞",
	"鱘": "鲟",
	"鱝": "鲼",
	"鱟": "鲎",
	"鱠": "鲙",
	"鱣": "鳣",
	"鱤": "鳡",
	"鱧": "鳢",
	"鱨": "鲿",
	"鱭": "鲚",
	"鱯": "鳠",
	"鱷": "鳄",
	"鱸": "鲈",
	"鱺": "鲡",
	"鼇": "鳌",
	"鳥": "鸟",
	"鳩": "鸠",
	"鳲": "鸤",
	"鳴": "鸣",
	"鳶": "鸢",
	"鴆": "鸩",
	"鴇": "鸨",
	"鴉": "鸦",
	"鴒": "鸰",
	"鴕": "鸵",
	"鴛": "鸳",
	"鴝": "鸲",
	"鴞": "鸮",
	"鴟": "鸱",
	"鴣": "鸪",
	"鴦": "鸯",
	"鴨": "鸭",
	"鴬": "鸴",
	"鴯": "鸸",
	"鴰": "鸹",
	"鴴": "鸻",
	"鴻": "鸿",
	"鴿": "鸽",
	"鵂": "鸺",
	"鵃": "鸼",
	"鵐": "鹀",
	"鵑": "鹃",
	"鵒": "鹆",
	"鵓": "鹁",
	"鵜": "鹈",
	"鵝": "鹅",
	"鵞": "鹅",
	"鵠": "鹄",
	"鵡": "鹉",
	"鵪": "鹌",
	"鵬": "鹏",
	"鵮": "鹐",
	"鵯": "鹎",
	"鵲": "鹊",
	"鵶": "鸦",
	"鵷": "鹓",
	"鵾": "鹍",
	"鶇": "鸫",
	"鶉": "鹑",
	"鶊": "鹒",
	"鶓": "鹋",
	"鶖": "鹙",
	"鶘": "鹕",
	"鶚": "鹗",
	"鶡": "鹖",
	"鶤": "鹍",
	"鶥": "鹛",
	"鶩": "鹜",
	"鶬": "鸧",
	"鶲": "鹟",
	"鶴": "鹤",
	"鶹": "鹠",
	"鶺": "鹡",
	"鶻": "鹘",
	"鶼": "鹣",
	"鶿": "鹚",
	"鷀": "鹚",
	"鷁": "鹢",
	"鷂": "鹞",
	"鷄": "鸡",
	"鷊": "鹝",
	"鷓": "鹧",
	"鷖": "鹥",
	"鷗": "鸥",
	"鷙": "鸷",
	"鷚": "鹨",
	"鷥": "鸶",
	"鷦": "鹪",
	"鷫": "鹔",
	"鷯": "鹩",
	"鷰": "燕",
	"鷲": "鹫",
	"鷳": "鹇",
	"鷴": "鹇",
	"鷸": "鹬",
	"鷹": "鹰",
	"鷺": "鹭",
	"鷼": "鹇",
	"鸇": "鹯",
	"鸌": "鹱",
	"鸎": "莺",
	"鸏": "鹲",
	"鸕": "鸬",
	"鸘": "鹴",
	"鸚": "鹦",
	"鸛": "鹳",
	"鸝": "鹂",
	"鸞": "鸾",
	"鹺": "鹾",
	"麥": "麦",
	"麩": "麸",
	"麪": "面",
	"麯": "曲",
	"麴": "曲",
	"麵": "面",
	"麽": "么",
	"黃": "黄",
	"黌": "黉",
	"黶": "黡",
	"黷": "黩",
	"黲": "黪",
	"黽": "黾",
	"黿": "鼋",
	"鼂": "鼌",
	"鼈": "鳖",
	"鼉": "鼍",
	"鼕": "冬",
	"鼴": "鼹",
	"齇": "齄",
	"齊": "齐",
	"齏": "齑",
	"齒": "齿",
	"齔": "龀",
	"齕": "龁",
	"齗": "龂",
	"齙": "龅",
	"齜": "龇",
	"齟": "龃",
	"齠": "龆",
	"齡": "龄",
	"齣": "齣",
	"齦": "龈",
	"齪": "龊",
	"齬": "龉",
	"齲": "龋",
	"齷": "龌",
	"龍": "龙",
	"龔": "龚",
	"龕": "龛",
	"龜": "龟",
	"䊷": "䌶",
	"𧩙": "䜥",
	"余": "余",
	"俔": "伣",
	"倈": "俫",
	"凈": "净",
	"剎": "刹",
	"叄": "叁",
	"吶": "呐",
	"喎": "㖞",
	"壈": "𡒄",
	"奬": "奖",
	"奼": "姹",
	"幺": "么",
	"弒": "弑",
	"彔": "录",
	"後": "后",
	"悞": "悮",
	"戱": "戯",
	"拾": "拾",
	"挩": "捝",
	"搵": "揾",
	"撝": "㧑",
	"擓": "㧟",
	"暨": "暨",
	"朮": "术",
	"杴": "锨",
	"梲": "棁",
	"榲": "榅",
	"槤": "梿",
	"檔": "档",
	"櫱": "蘖",
	"殨": "㱮",
	"殻": "壳",
	"沈": "沈",
	"澐": "沄",
	"灠": "漤",
	"熅": "煴",
	"畵": "画",
	"痾": "疴",
	"瘲": "疭",
	"瞜": "䁖",
	"瞭": "了",
	"瞶": "瞆",
	"礆": "硷",
	"禡": "祃",
	"窵": "窎",
	"筴": "䇲",
	"篔": "筼",
	"籖": "签",
	"糹": "纟",
	"紬": "䌷",
	"絅": "䌹",
	"絶": "绝",
	"緑": "绿",
	"縳": "䌸",
	"繸": "䍁",
	"纔": "才",
	"苎": "苧",
	"薀": "蕰",
	"薴": "苧",
	"藉": "借",
	"藴": "蕴",
	"虆": "蔂",
	"衕": "同",
	"覆": "复",
	"誾": "訚",
	"謡": "谣",
	"謭": "谫",
	"酇": "酂",
	"釒": "钅",
	"鉅": "钜",
	"鋭": "锐",
	"録": "录",
	"闇": "闇",
	"阪": "坂",
	"霢": "霡",
	"鞝": "绱",
	"飠": "饣",
	"骯": "肮",
	"鮝": "鲞",
	"䰾": "鲃",
	"䲁": "鳚",
	"鳬": "凫",
	"鳾": "䴓",
	"鴷": "䴕",
	"鵁": "䴔",
	"鶄": "䴖",
	"鶪": "䴗",
	"鷈": "䴘",
	"鷽": "鸴",
	"鷿": "䴙",
	"麫": "面",
	"龎": "厐",
	"㑹": "会",
	"涂": "涂",
	"錬": "炼",
	"壊": "坏",
	"丑": "丑",
	"么": "么",
	"几": "几",
	"后": "后",
	"斗": "斗",
	"干": "干",
	"虫": "虫",
	"岳": "岳",
	"卜": "卜",
	"于": "于",
	"里": "里",
	"范": "范",
	"朴": "朴",
	"咨": "咨",
	"划": "划",
	"杰": "杰",
	"面": "面",
	"舍": "舍",
	"松": "松",
	"云": "云",
	"咸": "鹹",
	"折": "折",
	"同": "同",
	"胡": "胡",
	"症": "症",
	"郁": "郁",
	"采": "采",
	"栖": "栖",
	"踪": "踪",
	"昵": "昵",
	"厘": "厘",
	"痲": "痳",
	"痳": "痳",
	"怜": "怜",
	"占": "占",
	"借": "借",
	"吨": "吨",
	"制": "制",
	"征": "征",
	"向": "向",
	"喂": "喂",
	"只": "只",
	"困": "困",
	"志": "志",
	"布": "布",
	"系": "系",
	"份": "分",
	"分": "分",
	"梁": "梁",
	"谷": "谷",
	"板": "板",
	"祢": "祢",
	"注": "注",
	"恒": "恒",
	"晒": "晒",
	"杆": "杆",
	"坂": "坂",
	"克": "克",
	"咏": "咏",
	"袜": "袜",
	"仆": "仆",
	"餧": "𫗪",
	"剗": "刬",
	"鏟": "铲",
	"繨": "𫄤",
	"劏": "㓥",
	"鎞": "𫔇",
	"札": "札",
	"污": "污",
	"游": "游",
	"伙": "伙",
	"御": "御",
	"咔": "咔",
	"凌": "凌",
	"扎": "扎",
	"痴": "痴",
	"嚯": "嚯",
	"姜": "姜",
	"扦": "扦",
	"捻": "捻",
	"沓": "沓",
	"栗": "栗",
	"挽": "挽",
	"灶": "灶",
	"霉": "霉",
	"欲": "欲",
	"十": "十",
	"卷": "卷",
	"熏": "熏",
	"吁": "吁",
	"龥": "龥",
	"跖": "跖",
	"硅": "硅",
	"修": "修",
	"犟": "犟",
	"剷": "剷",
	"噼": "噼",
	"劈": "劈",
	"擗": "擗",
	"核": "核",
	"憷": "憷",
	"呼": "呼",
	"唿": "唿",
	"嗬": "嗬",
	"呵": "呵",
	"唇": "唇",
	"升": "升",
	"溪": "溪",
	"渓": "渓",
	"嵠": "嵠",
	"佑": "佑",
	"偷": "偷",
	"瓮": "瓮",
	"暗": "暗",
	"痹": "痹",
	"雇": "雇",
	"秘": "秘",
	"周": "周",
	"檐": "檐",
	"涌": "涌",
	"家": "家",
	"亘": "亘",
	"泄": "泄",
	"佩": "佩",
	"剿": "剿",
	"沉": "沉",
	"榨": "榨",
	"筱": "筱",
	"彷": "彷",
	"岩": "岩",
	"噪": "噪",
	"雕": "雕",
	"蔑": "蔑",
	"蒙": "蒙",
	"碹": "碹",
	"勐": "勐",
	"猛": "猛",
};

export default exports as typeof import('./table');

